import i18n from '../locales';
import store from '../store';
import axios from 'axios';
import { EVENT } from '../constants/utils';
import routeDetailModalEscl from '../locales/es-CL/routeDetailModal.json';
import routeDetailModalEsmx from '../locales/es-MX/routeDetailModal.json';
import routeDetailModalEsco from '../locales/es-CO/routeDetailModal.json';
import routeDetailModalEnus from '../locales/en-US/routeDetailModal.json';
import { eventBus_routeDetailModal_routeDetailMap } from '../main';
//import { MarkerClusterer } from '@googlemaps/markerclusterer';
import moment from 'moment';
export default {
  name: 'RouteDetailMapV2',
  props: {
    gapi: {
      type: Object,
      default: null,
    },
  },
  i18n: {
    messages: {
      'en-US': { routeDetailModal: routeDetailModalEnus },
      'es-CL': { routeDetailModal: routeDetailModalEscl },
      'es-MX': { routeDetailModal: routeDetailModalEsmx },
      'es-CO': { routeDetailModal: routeDetailModalEsco },
    },
  },
  data() {
    return {
      apiKey: store.getters.apiKey,
      map: null,
      markerCluster: null,
      oms: null,
      infoWinOpen: false,
      usingVehicleMarker: false,
      allowAutoPageChange: false,
      route: null,
      markers: [],
      eventMarkers: [],
      waypointsMarkers: [],
      googleMarkers: [],
      geoFencePoints: [],
      drawnPolylines: [],
      realTimeLocationVeh: null,
      realTimeLocationCargo: null,
      realTimeLocationGpsControl: null,
      usePolyline: true,
      useRealTimeMarker: true,
      useRealTimeMarkerCargo: true,
      useRealTimeMarkerGpsControl: true,
      currentInfoWindow: null,
      colorIcon: {
        done: '#196984',
        pending: '#17a7d9',
      },
      colorIconLastmileV2: {
        unreacheable: '#686767',
        pending: '#6226F7',
        done: '#04bb04',
        rejected: '#ff0000',
        partial: '#eeb71f',
        default: '#7A46FB',
        depot: '#296280',
        active: '#995FFF',
        unactive: '#5D5D5E',
        realLocation: '#0096CA',
        strokeColor: '#3E3E3E',
      },
      iconPathArrow:
        'M20.4482 22.7296L10.2282 0L0 22.7296L1.3582 24.0896L10.2282 20.1896L19.0882 24.0896L20.4482 22.7296Z',
      iconPathCargo:
        'M20.94 11C20.48 6.83 17.17 3.52 13 3.06V1H11V3.06C6.83 3.52 3.52 6.83 3.06 11H1V13H3.06C3.52 17.17 6.83 20.48 11 20.94V23H13V20.94C17.17 20.48 20.48 17.17 20.94 13H23V11H20.94ZM12 19C8.13 19 5 15.87 5 12C5 8.13 8.13 5 12 5C15.87 5 19 8.13 19 12C19 15.87 15.87 19 12 19Z M16.5 10H15V8H8C7.45 8 7 8.45 7 9V14.5H8C8 15.33 8.67 16 9.5 16C10.33 16 11 15.33 11 14.5H14C14 15.33 14.67 16 15.5 16C16.33 16 17 15.33 17 14.5H18V12L16.5 10ZM9.5 15.25C9.085 15.25 8.75 14.915 8.75 14.5C8.75 14.085 9.085 13.75 9.5 13.75C9.915 13.75 10.25 14.085 10.25 14.5C10.25 14.915 9.915 15.25 9.5 15.25ZM16.25 10.75L17.23 12H15V10.75H16.25ZM15.5 15.25C15.085 15.25 14.75 14.915 14.75 14.5C14.75 14.085 15.085 13.75 15.5 13.75C15.915 13.75 16.25 14.085 16.25 14.5C16.25 14.915 15.915 15.25 15.5 15.25Z',
      pathOptionsPending: {
        strokeColor: '#6226F7',
        strokeOpacity: 0,
        icons: [
          {
            icon: {
              path: 'M 0,-1 0,1',
              strokeOpacity: 1,
              scale: 4,
            },
            offset: '0',
            repeat: '20px',
          },
        ],
      },
      pathOptionsDone: {
        strokeColor: '#196984',
        strokeOpacity: 1,
      },
      trafficEnabled: false,
      trafficLayer: null,
      zoneInfoWindow: null,
    };
  },
  async mounted() {
    const self = this;
    eventBus_routeDetailModal_routeDetailMap.$on('routeMapClicked', function (data) {
      self.route = data;
    });
    if (this.gapi == null) {
      console.error('Google API object is null. Cannot initialize the map.');
      return;
    }
    this.map = new this.gapi.maps.Map(this.$refs.mapGoogle, {
      center: { lat: -33.4283789, lng: -70.5407851 },
      zoom: 7,
      mapId: 'Lastmile_id', // 🔴 OBLIGATORIO
      mapTypeId: 'terrain',
      gestureHandling: 'greedy', // Cambia aquí si quieres permitir gestos
      disableDefaultUI: true, // Muestra los controles por defecto (incluye zoom)
      zoomControl: false, // o true
      mapTypeControl: false,
      streetViewControl: false,
      fullscreenControl: true,
      rotateControl: false,
    });

    this.trafficLayer = new this.gapi.maps.TrafficLayer();
    this.applyTrafficLayer();
  },
  methods: {
    createSvgIcon({ path, fill = '#000', width = 32, height = 32, rotation = 0 }) {
      const svgNS = 'http://www.w3.org/2000/svg';
      const svg = document.createElementNS(svgNS, 'svg');
      svg.setAttribute('width', width);
      svg.setAttribute('height', height);
      svg.setAttribute('viewBox', `0 0 ${width} ${height}`);
      svg.style.transform = `rotate(${rotation}deg)`;

      const shape = document.createElementNS(svgNS, 'path');
      shape.setAttribute('d', path);
      shape.setAttribute('fill', fill);

      svg.appendChild(shape);
      return svg;
    },
    getSecurePathEventInfo() {
      try {
        let result = `${store.getters.urlAPI}/securePathEvent/filter?`;
        const config = {
          headers: {
            'id-client': store.getters.clientId,
            Authorization: `Bearer ${store.getters.accessToken}`,
          },
        };
        if (this.route.id !== '-') {
          result += '&' + 'idRoute=' + this.route.id;
        }
        // result +=  '&' + 'idRoute=1776';
        let response = axios.get(result, config);
        return response;
      } catch (e) {
        console.log(e);
        return '';
      }
    },
    async prepareMapView(lastmileLite) {
      const markers = lastmileLite == null ? this.markers : this.markersLastmileLite;
      if (!markers || markers.length === 0) return { lat: 0, lng: 0 };
      /* Incluye la ubicacion del vehiculo si se necesita para calcular el centro
      if (
        this.realTimeLocationVeh &&
        this.useRealTimeMarker &&
        this.realTimeLocationVeh.position &&
        this.realTimeLocationVeh.position.lat &&
        this.realTimeLocationVeh.position.lng
      ) {
        markers.push(this.realTimeLocationVeh);
      }*/
      if (markers.length === 1) {
        return this._getLatLngFromMarker(markers[0]);
      } else if (markers.length === 2) {
        const pos1 = this._getLatLngFromMarker(markers[0]);
        const pos2 = this._getLatLngFromMarker(markers[1]);
        return {
          lat: (pos1.lat + pos2.lat) / 2,
          lng: (pos1.lng + pos2.lng) / 2,
        };
      } else {
        let latLowest = Number.POSITIVE_INFINITY;
        let latHighest = Number.NEGATIVE_INFINITY;
        let lngLowest = Number.POSITIVE_INFINITY;
        let lngHighest = Number.NEGATIVE_INFINITY;

        markers.forEach((marker) => {
          const pos = this._getLatLngFromMarker(marker);
          if (pos.lat < latLowest) latLowest = pos.lat;
          if (pos.lat > latHighest) latHighest = pos.lat;
          if (pos.lng < lngLowest) lngLowest = pos.lng;
          if (pos.lng > lngHighest) lngHighest = pos.lng;
        });

        return {
          lat: latLowest + (latHighest - latLowest) / 2,
          lng: lngLowest + (lngHighest - lngLowest) / 2,
        };
      }
    },
    _getLatLngFromMarker(marker) {
      // Si marker.position es LatLng, usa .lat()/.lng(), si es objeto, usa .lat/.lng
      if (typeof marker.position.lat === 'function') {
        return { lat: marker.position.lat(), lng: marker.position.lng() };
      }
      return { lat: marker.position.lat, lng: marker.position.lng };
    },
    async setMap(gapi, trips, pointSelected, zones) {
      this.markers = [];
      //Se guardan los trips de manera local.
      await this.setMarkers(trips);
      await this.setTrips(zones, false);

      const centerMap = pointSelected != null ? pointSelected : await this.prepareMapView();

      //Por cada viaje, se prepara un marker en mapa.
      if (this.markers.length > 1) {
        const bounds = new gapi.maps.LatLngBounds();
        this.markers.forEach((marker) => {
          const loc = new gapi.maps.LatLng(marker.position.lat, marker.position.lng);
          bounds.extend(loc);
        });
        await this.map.fitBounds(bounds);
      }
      //Edito el centro del mapa
      this.map.setCenter(centerMap);
      //Si hay algun punto seleccionado aplica zoom al punto
      if (pointSelected != null) {
        this.map.setZoom(15);
      }
    },
    /**
     * Este metodo coloca un marcador en el mapa con una zona circular alrededor
     * Usado principalmente para el modal de crear spots ya que solo muestra la ubicacion de lo seleccionado
     * @param {*} position
     */
    async setOneMarkerWZone(position) {
      const lat = Number(position.lat);
      const lng = Number(position.lng);
      const marker = await this.prepareMarker(1, lat, lng, 'Spot', 'Spot', null, this.colorIconLastmileV2.default);
      this.makeCircle([{ lat: lat, lon: lng, radio: 100 }]);
      this.map.setCenter(marker.position);
      this.map.setZoom(17);
    },
    /**
     * Metodo que construye la linea del recorrido del vehículo segun los points
     * Ademas indica la ubicacion y direccion del vehículo a traves de realTimePoint
     * @param {Array} points
     * @param {JSON} realTimePoint
     */
    async setMapRealTime(points, realTimePoint) {
      // Limpia la polyline anterior
      if (this.realTimePolyline) {
        this.realTimePolyline.setMap(null);
        this.realTimePolyline = null;
      }
      // Actualiza el marcador de vehículo
      this.addPointToRealTime(points, realTimePoint);
    },

    /**
     * Metodo que añade puntos al recorrido del vehículo, ademas construye el nuevo marcador para el vehículo en su nueva posicion
     * @param {Array} points
     * @param {JSON} realTimePoint
     */
    addPointToRealTime(points, realTimePoint) {
      if (!this.useRealTimeMarker) {
        if (this.realTimeLocationVeh) this.realTimeLocationVeh.map = null;
        return;
      }
      const position = { lat: realTimePoint.lat, lng: realTimePoint.lon };
      const parser = new DOMParser();
      const svg = `<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g filter="url(#filter0_d_2918_10139)">
      <circle cx="16.5713" cy="16.5703" r="11.75" fill="white" stroke="black" stroke-width="0.5"/>
      <path d="M12.5713 20.1953L12.5713 20.5391C12.5713 20.8255 12.4741 21.069 12.2796 21.2695C12.0852 21.4701 11.8491 21.5703 11.5713 21.5703C11.2935 21.5703 11.0574 21.4701 10.863 21.2695C10.6685 21.069 10.5713 20.8255 10.5713 20.5391L10.5713 15.6234C10.5713 15.5432 10.5768 15.463 10.588 15.3828C10.5991 15.3026 10.6157 15.2281 10.638 15.1594L11.888 11.4984C11.9768 11.2234 12.138 11 12.3713 10.8281C12.6046 10.6563 12.8657 10.5703 13.1546 10.5703L19.988 10.5703C20.2768 10.5703 20.538 10.6563 20.7713 10.8281C21.0046 11 21.1657 11.2234 21.2546 11.4984L22.5046 15.1594C22.5268 15.2281 22.5435 15.3026 22.5546 15.3828C22.5657 15.463 22.5713 15.5432 22.5713 15.6234L22.5713 20.5391C22.5713 20.8255 22.4741 21.069 22.2796 21.2695C22.0852 21.4701 21.8491 21.5703 21.5713 21.5703C21.2935 21.5703 21.0574 21.4701 20.863 21.2695C20.6685 21.069 20.5713 20.8255 20.5713 20.5391L20.5713 20.1953L12.5713 20.1953ZM12.438 14.0078L20.7046 14.0078L20.0046 11.9453L13.138 11.9453L12.438 14.0078ZM13.5713 18.1328C13.8491 18.1328 14.0852 18.0326 14.2796 17.832C14.4741 17.6315 14.5713 17.388 14.5713 17.1016C14.5713 16.8151 14.4741 16.5716 14.2796 16.3711C14.0852 16.1706 13.8491 16.0703 13.5713 16.0703C13.2935 16.0703 13.0574 16.1706 12.863 16.3711C12.6685 16.5716 12.5713 16.8151 12.5713 17.1016C12.5713 17.388 12.6685 17.6315 12.863 17.832C13.0574 18.0326 13.2935 18.1328 13.5713 18.1328ZM19.5713 18.1328C19.8491 18.1328 20.0852 18.0326 20.2796 17.832C20.4741 17.6315 20.5713 17.388 20.5713 17.1016C20.5713 16.8151 20.4741 16.5716 20.2796 16.3711C20.0852 16.1706 19.8491 16.0703 19.5713 16.0703C19.2935 16.0703 19.0574 16.1706 18.863 16.3711C18.6685 16.5716 18.5713 16.8151 18.5713 17.1016C18.5713 17.388 18.6685 17.6315 18.863 17.832C19.0574 18.0326 19.2935 18.1328 19.5713 18.1328ZM11.9046 18.8203L21.238 18.8203L21.238 15.3828L11.9046 15.3828L11.9046 18.8203Z" fill="#3E3E3E"/>
      </g>
      <defs>
      <filter id="filter0_d_2918_10139" x="-0.000139236" y="-0.0011158" width="33.1429" height="33.1429" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
      <feFlood flood-opacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset/>
      <feGaussianBlur stdDeviation="2.28571"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2918_10139"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2918_10139" result="shape"/>
      </filter>
      </defs>
      </svg>`;
      const pin = parser.parseFromString(svg, 'image/svg+xml').documentElement;
      if (position && position.lat != 0 && position.lng != 0) {
        if (!this.realTimeLocationVeh) {
          this.realTimeLocationVeh = new this.gapi.maps.marker.AdvancedMarkerElement({
            position,
            map: this.map,
            content: pin,
            title: 'Vehículo',
          });
        } else {
          this.realTimeLocationVeh.position = position;
          this.realTimeLocationVeh.content = pin;
          this.realTimeLocationVeh.map = this.map;
        }
      }
      // Si la polyline existe y está habilitada, actualiza sus puntos
      if (this.usePolyline && points.length > 0) {
        const pathPoints = points.map((p) => ({ lat: p.lat, lng: p.lng }));
        if (this.realTimePolyline) {
          this.realTimePolyline.setPath(pathPoints);
        } else {
          const icon = [
            {
              icon: {
                path: 'M-2 3.1L0 1L2 3.1', // Tu path SVG
                strokeOpacity: 1,
                scale: 2, // Ajusta el tamaño de la flecha
                strokeColor: '#6226F7', // Color de la flecha
              },
              offset: '0px', // Puedes poner '30px', '60px', etc. para repetir la flecha
              repeat: '55px', // Menor valor = más flechas
            },
          ];
          this.realTimePolyline = this.buildPolyline(pathPoints, '#6226F7', 1, 4, icon);
        }
      }
    },
    /**
     * Metodo que construye el nuevo marcador para la carga en su nueva posicion
     * @param {Array} points
     * @param {JSON} realTimePoint
     */
    updateRealTimeCargo(realTimePoint) {
      if (!this.useRealTimeMarkerCargo) {
        if (this.realTimeLocationCargo) this.realTimeLocationCargo.map = null;
        return;
      }
      const position = { lat: realTimePoint.lat, lng: realTimePoint.lon };
      const parser = new DOMParser();
      const svg = `<svg width="34" height="34" viewBox="0 0 34 34" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g filter="url(#filter0_d_2918_10528)">
        <circle cx="16.5713" cy="16.5703" r="11.75" fill="white" stroke="black" stroke-width="0.5"/>
        <path d="M14.8302 22.5703C14.3481 22.5703 13.9115 22.4494 13.5202 22.2075C13.129 21.9656 12.8339 21.6282 12.6349 21.1953H11.4811C10.9506 21.1953 10.4997 21.0171 10.1283 20.6606C9.75697 20.3041 9.57129 19.8712 9.57129 19.362V16.612C9.57129 16.2339 9.71154 15.9102 9.99205 15.6409C10.2725 15.3716 10.6098 15.237 11.0036 15.237H13.8684V12.9453H10.293C10.0904 12.9453 9.91943 12.8798 9.78018 12.7488C9.64092 12.6178 9.57129 12.4555 9.57129 12.2618C9.57129 12.0682 9.63992 11.9045 9.77719 11.7708C9.91446 11.6372 10.0846 11.5703 10.2875 11.5703H18.6429C19.0368 11.5703 19.374 11.7049 19.6545 11.9742C19.935 12.2435 20.0753 12.5672 20.0753 12.9453V19.8203H22.1044L21.9453 19.6675C21.7994 19.5275 21.7265 19.3652 21.7265 19.1806C21.7265 18.9959 21.7962 18.8336 21.9357 18.6936C22.088 18.5535 22.2603 18.4835 22.4526 18.4835C22.6449 18.4835 22.814 18.5535 22.9599 18.6936L24.3525 20.0304C24.4983 20.1658 24.5713 20.3238 24.5713 20.5044C24.5713 20.6849 24.4983 20.8452 24.3525 20.9852L22.9599 22.322C22.814 22.4621 22.6482 22.5289 22.4625 22.5226C22.2769 22.5162 22.1111 22.443 21.9652 22.303C21.8193 22.1629 21.7464 22.0006 21.7464 21.816C21.7464 21.6314 21.8193 21.469 21.9652 21.329L22.1044 21.1953H17.0116C16.8259 21.6409 16.5365 21.9815 16.1432 22.217C15.75 22.4525 15.3123 22.5703 14.8302 22.5703ZM15.3007 15.237H18.6429V12.9453H15.3007V15.237ZM14.8233 21.1953C15.0938 21.1953 15.3206 21.1075 15.5037 20.9318C15.6867 20.7561 15.7782 20.5384 15.7782 20.2786C15.7782 20.0189 15.6867 19.8012 15.5037 19.6255C15.3206 19.4498 15.0938 19.362 14.8233 19.362C14.5527 19.362 14.3259 19.4498 14.1429 19.6255C13.9599 19.8012 13.8684 20.0189 13.8684 20.2786C13.8684 20.5384 13.9599 20.7561 14.1429 20.9318C14.3259 21.1075 14.5527 21.1953 14.8233 21.1953Z" fill="#3E3E3E"/>
        </g>
        <defs>
        <filter id="filter0_d_2918_10528" x="-0.000139236" y="-0.0011158" width="33.1429" height="33.1429" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
        <feFlood flood-opacity="0" result="BackgroundImageFix"/>
        <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
        <feOffset/>
        <feGaussianBlur stdDeviation="2.28571"/>
        <feComposite in2="hardAlpha" operator="out"/>
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"/>
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_2918_10528"/>
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_2918_10528" result="shape"/>
        </filter>
        </defs>
        </svg>
        `;
      const pin = parser.parseFromString(svg, 'image/svg+xml').documentElement;

      if (!this.realTimeLocationCargo) {
        this.realTimeLocationCargo = new this.gapi.maps.marker.AdvancedMarkerElement({
          position,
          map: this.map,
          content: pin,
          title: 'Carga',
        });
      } else {
        this.realTimeLocationCargo.position = position;
        this.realTimeLocationCargo.content = pin;
        this.realTimeLocationCargo.map = this.map;
      }
    },
    /**
     * Metodo que construye el nuevo marcador para el gps control en su nueva posicion
     * @param {Array} points
     * @param {JSON} realTimePoint
     */
    updateRealTimeGpsControl(realTimePoint) {
      if (!this.useRealTimeMarkerGpsControl) {
        if (this.realTimeLocationGpsControl) this.realTimeLocationGpsControl.map = null;
        return;
      }
      const position = { lat: realTimePoint.lat, lng: realTimePoint.lon };
      const svgIcon = this.createSvgIcon({
        path: this.iconPathCargo,
        fill: '#000',
        width: 32,
        height: 32,
      });

      if (!this.realTimeLocationGpsControl) {
        this.realTimeLocationGpsControl = new this.gapi.maps.marker.AdvancedMarkerElement({
          position,
          map: this.map,
          content: svgIcon,
          title: 'Carga',
        });
      } else {
        this.realTimeLocationGpsControl.position = position;
        this.realTimeLocationGpsControl.content = svgIcon;
        this.realTimeLocationGpsControl.map = this.map;
      }
    },
    enablePolyline(polylineEnabled) {
      this.usePolyline = polylineEnabled;
      if (this.realTimePolyline) {
        this.realTimePolyline.setMap(polylineEnabled ? this.map : null);
      }
    },
    enableRealTimeMarker(markerEnabled) {
      this.useRealTimeMarker = markerEnabled;
      if (this.realTimeLocationVeh) {
        this.realTimeLocationVeh.map = markerEnabled ? this.map : null;
      }
    },
    enableRealTimeMarkerCargo(markerEnabled) {
      this.useRealTimeMarkerCargo = markerEnabled;
      if (this.realTimeLocationCargo) {
        this.realTimeLocationCargo.map = markerEnabled ? this.map : null;
      }
    },
    enableRealTimeMarkerGpsControl(markerEnabled) {
      this.useRealTimeMarkerGpsControl = markerEnabled;
      if (this.realTimeLocationGpsControl) {
        this.realTimeLocationGpsControl.map = markerEnabled ? this.map : null;
      }
    },
    async outOfRouteMarkers(points) {
      const markerType = 'event';
      const markerColor = '#FF0000';
      points.forEach(async (point, index) => {
        //Se le suma el indice para que siempre aparezca como prioridad
        const outRouteMarker = await this.prepareMarker(
          index + 20,
          point.lat,
          point.lon,
          'Evento salida de ruta',
          markerType,
          null,
          markerColor,
        );
        outRouteMarker.trip = point;
        this.setInfoContent(index, outRouteMarker, markerType, markerColor);
        this.markers.push(outRouteMarker);
      });
    },
    async setMarkers(trips, lineHaulModal = false) {
      this.trips = trips;
      this.markers = [];
      if (trips.length === 1) {
        // Primer marcador (origen) - icono base
        const originColor = this.markerColor({ state: 'PENDING' });
        let markerType = 'Depot';
        const originMarker = await this.prepareMarker(
          0,
          trips[0].coordinates.origin.lat,
          trips[0].coordinates.origin.lng,
          'Base',
          markerType,
          null,
          originColor,
        );
        originMarker.trip = trips[0];
        this.setInfoContent(0, originMarker, markerType, originColor, lineHaulModal);
        this.markers.push(originMarker);

        // Segundo marcador (destino) - icono trip
        const destColor = this.markerColor(trips[0]);
        markerType = 'Trip';
        const destMarker = await this.prepareMarker(
          1,
          trips[0].coordinates.destination.lat,
          trips[0].coordinates.destination.lng,
          'Trip',
          markerType,
          null,
          destColor,
        );
        destMarker.trip = trips[0];
        this.setInfoContent(1, destMarker, markerType, destColor, lineHaulModal);
        this.markers.push(destMarker);
      } else {
        for (let index = 0; index < trips.length; index++) {
          const trip = trips[index];
          // Primer marcador (origen) - icono base
          if (index === 0) {
            const originColor = this.markerColor({ state: 'PENDING' });
            let markerType = 'Depot';
            const originMarker = await this.prepareMarker(
              index,
              trip.coordinates.origin.lat,
              trip.coordinates.origin.lng,
              'Base',
              markerType,
              null,
              originColor,
            );
            originMarker.trip = trip;
            this.markers.push(originMarker);
            this.setInfoContent(0, originMarker, markerType, originColor, lineHaulModal);
          }

          // Marcadores intermedios (trip)
          else if (index <= trips.length - 1) {
            const tripColor = this.markerColor(trips[index - 1]);
            let markerType = 'Trip';
            const tripMarker = await this.prepareMarker(
              index,
              trip.coordinates.origin.lat,
              trip.coordinates.origin.lng,
              'Trip',
              markerType,
              null,
              tripColor,
            );
            tripMarker.trip = trips[index - 1];
            this.markers.push(tripMarker);
            this.setInfoContent(index, tripMarker, markerType, tripColor, lineHaulModal);

            // Último marcador (destino) - icono base
            if (index === trips.length - 1) {
              const destColor = this.markerColor(trip);
              let markerType = 'Depot';
              const destMarker = await this.prepareMarker(
                index + 1,
                trip.coordinates.destination.lat,
                trip.coordinates.destination.lng,
                'Base',
                markerType,
                null,
                destColor,
              );
              destMarker.trip = trip;
              this.markers.push(destMarker);
              this.setInfoContent(index + 1, destMarker, markerType, destColor, lineHaulModal);
            }
          }
        }
      }
    },
    async setMapTrips(trips, zones) {
      this.trips = trips;
      const linehaulModal = true;
      await this.setMarkers(trips, linehaulModal);
      await this.setTrips(zones, true);
      const centerMap = await this.prepareMapView();
      //Por cada viaje, se prepara un marker en mapa.
      if (this.markers.length > 1) {
        const bounds = new this.gapi.maps.LatLngBounds();
        this.markers.forEach((marker) => {
          const loc = new this.gapi.maps.LatLng(marker.position.lat, marker.position.lng);
          bounds.extend(loc);
        });
        if (this.realTimeLocationVeh && this.useRealTimeMarker) {
          const realTimeLoc = new this.gapi.maps.LatLng(
            this.realTimeLocationVeh.position.lat,
            this.realTimeLocationVeh.position.lng,
          );
          bounds.extend(realTimeLoc);
        }
        await this.map.fitBounds(bounds);
      }
      //Edito el centro del mapa
      this.map.setCenter(centerMap);
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que prepara los trips en el mapa.
     * @param {Array} trips, es el arreglo de trips.
     */
    async setTrips(zones, newLineHaulModal) {
      this.clearZones();
      if (zones != null) {
        this.drawZones(zones);
      }
      const requireIcon = true;
      await this.markers.forEach(async (marker, index) => {
        this.preparePathInMap(this.markers, marker, index, requireIcon, newLineHaulModal);
      });
    },
    /**
     * Se encarga de preparar los servicios de dirección, dibuja en el mapa el tramo que hay entre dos puntos (Incluyendo sus waypoints)
     * @param {*} gapi referencia al api de google
     * @param {Array} markersList Listado de marcadores (Dentro de ellos pueden haber waypoints)
     * @param {Marker} routeTemporal Marcador que se va a procesar
     * @param {Integer} index Indice de la posición de routeTemporal en el array markerList
     */
    async preparePathInMap(markersList, routeTemporal, index, requireIcon = false, newLineHaulModal = false) {
      //Configuración de los iconos del trazado
      if (index <= markersList.length - 1) {
        let waypoints = routeTemporal.waypoints || [];
        routeTemporal.trip.originAddress.lng = routeTemporal.trip.originAddress.lon;
        const origin = { location: { latLng: this.getLatLng(routeTemporal.trip.originAddress) } };
        routeTemporal.trip.destinationAddress.lng = routeTemporal.trip.destinationAddress.lon;
        const destination = { location: { latLng: this.getLatLng(routeTemporal.trip.destinationAddress) } };
        const intermediates = waypoints.map((wp) => ({
          location: { latLng: this.getLatLng(wp.location) },
        }));

        const requestBody = {
          origin,
          destination,
          intermediates,
          travelMode: 'DRIVE',
          languageCode: 'es',
          regionCode: 'CL', // o 'MX'
          computeAlternativeRoutes: false,
          routingPreference: 'TRAFFIC_AWARE',
        };
        let iconConfig = [
          {
            icon: {
              path: this.gapi.maps.SymbolPath.FORWARD_CLOSED_ARROW,
              scale: 3,
              fillOpacity: 1,
            },
            repeat: '50px',
          },
        ];
        if (newLineHaulModal) {
          iconConfig = [
            // Línea punteada
            {
              icon: {
                path: 'M 0,-1 0,1', // segmento corto
                strokeOpacity: 0.8,
                scale: 3, // Cambia este valor para ajustar el tamaño del segmento
                strokeColor: routeTemporal.trip.routeColor,
              },
              offset: '0px',
              repeat: '15px', // Menor valor = más puntos
            },
            // Flecha personalizada SVG
            {
              icon: {
                path: 'M-2 3.1L0 1L2 3.1', // Tu path SVG
                strokeOpacity: 1,
                scale: 2, // Ajusta el tamaño de la flecha
                strokeColor: routeTemporal.trip.routeColor, // Color de la flecha
              },
              offset: '0px', // Puedes poner '30px', '60px', etc. para repetir la flecha
              repeat: '55px', // Menor valor = más flechas
            },
          ];
        }
        await this.getGoogleComputeRoute(
          requestBody,
          routeTemporal.trip.routeColor,
          newLineHaulModal ? 0 : 0.7,
          routeTemporal.trip.widthRoute,
          requireIcon ? iconConfig : null,
        );
      }
    },
    getLatLng(position) {
      return {
        latitude: typeof position.lat === 'function' ? position.lat() : position.lat,
        longitude: typeof position.lng === 'function' ? position.lng() : position.lng,
      };
    },
    async getGoogleComputeRoute(requestBody, strokeColor, strokeOpacity, strokeWeight, icon) {
      try {
        const url = 'https://routes.googleapis.com/directions/v2:computeRoutes';
        const config = {
          headers: {
            'Content-Type': 'application/json',
            'X-Goog-Api-Key': this.apiKey,
            'X-Goog-FieldMask': 'routes.legs.steps.polyline.encodedPolyline',
          },
        };
        const response = await axios.post(url, requestBody, config);
        const data = response.data;
        if (data.routes && data.routes.length > 0) {
          const route = data.routes[0];
          const path = [];
          route.legs.forEach((leg) => {
            leg.steps.forEach((step) => {
              if (step.polyline && step.polyline.encodedPolyline) {
                path.push(...this.decodePolyline(step.polyline.encodedPolyline));
              }
            });
          });
          const pathOffset = this.offsetPolyline(path, 2.5);
          return this.buildPolyline(pathOffset, strokeColor, strokeOpacity, strokeWeight, icon);
        } else {
          console.log('No se pudo obtener la ruta entre estos puntos.', data);
          return null;
        }
      } catch (error) {
        console.error('Error al consultar la API de Routes:', error);
        return null;
      }
    },
    offsetLatLng(lat, lng, bearing, distanceMeters) {
      const earthRadius = 6378137; // metros
      const d = distanceMeters / earthRadius;
      const bearingRad = (bearing * Math.PI) / 180;

      const lat1 = (lat * Math.PI) / 180;
      const lng1 = (lng * Math.PI) / 180;

      const lat2 = Math.asin(Math.sin(lat1) * Math.cos(d) + Math.cos(lat1) * Math.sin(d) * Math.cos(bearingRad));
      const lng2 =
        lng1 +
        Math.atan2(Math.sin(bearingRad) * Math.sin(d) * Math.cos(lat1), Math.cos(d) - Math.sin(lat1) * Math.sin(lat2));

      return {
        lat: (lat2 * 180) / Math.PI,
        lng: (lng2 * 180) / Math.PI,
      };
    },
    // Para cada segmento, calcula el bearing y desplaza el punto perpendicular
    offsetPolyline(path, offsetMeters) {
      const offsetPath = [];
      let perpBearing = 0; // Inicializa fuera del bucle
      for (let i = 0; i < path.length - 1; i++) {
        const p1 = path[i];
        const p2 = path[i + 1];
        // Calcula el bearing del segmento
        const bearing =
          (Math.atan2(
            Math.sin(((p2.lng - p1.lng) * Math.PI) / 180) * Math.cos((p2.lat * Math.PI) / 180),
            Math.cos((p1.lat * Math.PI) / 180) * Math.sin((p2.lat * Math.PI) / 180) -
              Math.sin((p1.lat * Math.PI) / 180) *
                Math.cos((p2.lat * Math.PI) / 180) *
                Math.cos(((p2.lng - p1.lng) * Math.PI) / 180),
          ) *
            180) /
          Math.PI;
        // Bearing perpendicular (90 grados a la derecha)
        perpBearing = bearing + 90;
        offsetPath.push(this.offsetLatLng(p1.lat, p1.lng, perpBearing, offsetMeters));
      }
      // Último punto
      if (path.length > 1) {
        const last = path[path.length - 1];
        offsetPath.push(this.offsetLatLng(last.lat, last.lng, perpBearing, offsetMeters));
      }
      return offsetPath;
    },
    buildPolyline(path, strokeColor, strokeOpacity, strokeWeight, iconConfig) {
      const polylineOptions = {
        path,
        map: this.map,
        strokeColor: strokeColor,
        strokeOpacity: strokeOpacity,
        strokeWeight: strokeWeight,
      };
      if (iconConfig && iconConfig.length > 0) {
        polylineOptions.icons = iconConfig;
      }
      return new this.gapi.maps.Polyline(polylineOptions);
    },
    makeCircle(zone, zoneMeta = {}) {
      let radius = zone[0].radio;
      let center = {
        lat: zone[0].lat,
        lng: zone[0].lon,
      };
      const circleZone = new this.gapi.maps.Circle({
        strokeColor: 'rgba(98, 38, 247, 1)',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: 'rgba(98, 38, 247, 1)',
        fillOpacity: 0.35,
        map: this.map,
        center: center,
        radius: radius,
      });
      circleZone.addListener('click', (event) => {
        this.openZoneInfoWindow(event?.latLng || center, zoneMeta);
      });
      this.geoFencePoints.push(circleZone);
    },
    makePolygon(zone, zoneMeta = {}) {
      let zonesFormat = [];
      zone.forEach((point) => {
        zonesFormat.push({
          lat: point.lat,
          lng: point.lon,
        });
      });
      const polygonZone = new this.gapi.maps.Polygon({
        paths: zonesFormat,
        strokeColor: 'rgba(98, 38, 247, 1)',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: 'rgba(98, 38, 247, 1)',
        fillOpacity: 0.35,
        map: this.map,
      });
      polygonZone.addListener('click', (event) => {
        const defaultPosition = zonesFormat[0] || this.map?.getCenter();
        this.openZoneInfoWindow(event?.latLng || defaultPosition, zoneMeta);
      });
      this.geoFencePoints.push(polygonZone);
    },
    async setSpotsWRoute(initBaseList, acitivitySpotList, lastBaseList, idRoutePairing, geofence, vehicleLocation) {
      this.usingVehicleMarker = false;
      this.infoWinOpen = false;
      //Se encarga de limpiar el cluster si es que existe
      this.cleanCluster();
      //Limpio marcadores de google
      this.cleanMapMarkers();
      //Limpio el spiderfier
      this.cleanMarkersFromSpiderfier();
      //Limpio rendereizados en el mapa
      this.setMapNull();
      //Seteo el api como variable global
      //Se guardan los trips de manera local.
      let pointsRender = [];
      for (let i = 0; i <= idRoutePairing; i++) {
        pointsRender = this.createMarkers(initBaseList, this.googleMarkers, pointsRender, 'Depot', i);
        pointsRender = this.createMarkers(acitivitySpotList, this.googleMarkers, pointsRender, 'Trip', i);
        pointsRender = this.createMarkers(lastBaseList, this.googleMarkers, pointsRender, 'Depot', i);
      }
      if (vehicleLocation) {
        const indexMarker = acitivitySpotList.length + 3;
        const name = vehicleLocation.plate;
        const lat = vehicleLocation.lat;
        const lon = vehicleLocation.lon;
        //const hasRealLocation = false;
        //Si el marcador es bodega se pasa nulo debido a que el marcador es una imagen para las bodegas
        let colorIcon = this.markerColor(vehicleLocation);
        this.actualPositionVeh = this.prepareMarker(
          indexMarker,
          lat,
          lon,
          name,
          'Vehicle',
          vehicleLocation.state,
          colorIcon,
        );
      }

      //Se obtiene el punto central a partir de las ubicaciones de los marcadores
      const centerMap = await this.prepareMapViewGoogle(this.googleMarkers);

      this.map.setCenter(centerMap);
      if (geofence !== null && geofence !== undefined) {
        this.makePolygonGeofence(this.markersLastmileLite, this.gapi, geofence.zone, geofence.name);
      }
      //Por cada viaje, se prepara un marker en mapa.
      if (this.googleMarkers.length > 1) {
        this.oms.clearMarkers();
        let bounds = new this.gapi.maps.LatLngBounds();
        this.googleMarkers.forEach((marker) => {
          //Setea el marcador en el mapa
          marker.setMap(this.map);
          //Cuando se clickea un marcador busca si la operación del marcador tiene registrado una ubicación donde fue ejecutada
          marker.addListener('click', () => {
            this.setMarkerRealLocationGoogle(this.googleMarkers, marker);
          });
          this.oms.addMarker(marker);
          bounds.extend(new this.gapi.maps.LatLng(marker.position.lat(), marker.position.lng()));
        });
        if (this.actualPositionVeh) {
          this.actualPositionVeh.setMap(this.map);
          this.oms.addMarker(this.actualPositionVeh);
          bounds.extend(
            new this.gapi.maps.LatLng(this.actualPositionVeh.position.lat(), this.actualPositionVeh.position.lng()),
          );
        }
        await this.$refs.mapGoogle.$mapPromise.then((map) => {
          map.fitBounds(bounds);
        });
      }
      pointsRender.forEach((routeTemporal, index) => {
        //Calcula el camino entre cada uno de los marcadores existentes
        this.preparePathInMapGoogle(pointsRender, routeTemporal, index, true);
      });
    },
    /**
     * Metodo que prepara el trazado en el mapa de google entre un origen y un destino, con multiples puntos
     * @param {*} markersList Listado de todos los puntos por los cuales debe viajar el vehiculo
     * @param {*} routeTemporal Ruta actual que debe realizar un vehiculo
     * @param {*} index
     */
    async preparePathInMapGoogle(markersList, routeTemporal, index, iconRequired = false, configStroke = null) {
      if (this.drawnPolylines && this.drawnPolylines.length > 0) {
        this.drawnPolylines.forEach((polyline) => polyline.setMap(null));
        this.drawnPolylines = [];
      }
      //Configuración de los iconos del trazado
      if (index <= markersList.length - 2) {
        let waypoints = routeTemporal.waypoints || [];
        const origin = { location: { latLng: this.getLatLng(routeTemporal.position) } };
        const destination = { location: { latLng: this.getLatLng(markersList[index + 1].position) } };
        const intermediates = waypoints.map((wp) => ({
          location: { latLng: this.getLatLng(wp.location) },
        }));
        //Configuración para construir el trazado (polyline)
        const {
          strokeColor = this.routePathSimpleLastmileV2.strokeColor,
          strokeOpacity = 1,
          strokeWeight = 6,
        } = configStroke || {};
        //Request body para el endpoint de calcular la ruta
        const requestBody = {
          origin,
          destination,
          intermediates,
          travelMode: 'DRIVE',
          languageCode: 'es',
          regionCode: 'CL', // o 'MX'
          computeAlternativeRoutes: false,
          routingPreference: 'TRAFFIC_AWARE',
        };
        const iconConfig = [
          {
            icon: {
              path: this.gapi.maps.SymbolPath.FORWARD_CLOSED_ARROW,
              scale: 3,
              fillOpacity: 1,
            },
            repeat: '50px',
          },
        ];
        const polyline = await this.getGoogleComputeRoute(
          requestBody,
          strokeColor,
          strokeOpacity,
          strokeWeight,
          iconRequired ? iconConfig : null,
        );
        if (polyline) {
          this.drawnPolylines.push(polyline);
        }
      }
    },
    async setMarkerRealLocationGoogle(globalArray, marker) {
      if (globalArray.length > 0) {
        const lastPosition = globalArray.length - 1;
        //Si el marcador seleccionado no es de ubicación real y ya hay algun marcador de ubicación real en el mapa, entonces se elimina
        if (
          !marker.trip.typeName.includes('Ubicación de ejecución') &&
          globalArray[lastPosition].trip.typeName.includes('Ubicación de ejecución')
        ) {
          const deletedMarker = globalArray.pop();
          deletedMarker.setMap(null);
          this.oms.removeMarker(deletedMarker);
        }
        //Valida que la ubicación real tenga datos validos, si existen los datos entonces redibuja los marcadores en el mapa
        if (
          marker.type !== 'Base' &&
          marker.realLocation &&
          marker.realLocation.lat !== undefined &&
          marker.realLocation.lat !== 0 &&
          marker.realLocation.lon !== undefined &&
          marker.realLocation.lon !== 0
        ) {
          const markerRealPosition = this.prepareMarker(
            marker.index + globalArray.length,
            marker.realLocation.lat,
            marker.realLocation.lon,
            `${marker.trip.typeName} Ubicación de ejecución`,
            'Trip',
            null,
            this.colorIconLastmileV2.realLocation,
          );
          markerRealPosition.setMap(this.map);
          this.oms.addMarker(markerRealPosition);
          globalArray.push(markerRealPosition);

          let bounds = new this.gapi.maps.LatLngBounds();
          globalArray.forEach((marker) => {
            bounds.extend(new this.gapi.maps.LatLng(marker.position.lat(), marker.position.lng()));
          });
          await this.$refs.mapGoogle.$mapPromise.then((map) => {
            map.fitBounds(bounds);
          });
        }
      }
    },

    /**
     * Metodo que dibuja el mapa segun los puntos claves que uno le manda
     * @param {Google api} gapi
     * @param {Array} trips
     * @param {Array} waypoints
     * @param {Boolean} edit
     * @param {Integer} widthLine
     */
    async setMapWithPoints(gapi, trips, waypoints, edit, widthLine) {
      this.infoWinOpen = false;
      // Se realiza una limpieza de marcadores en el mapa para limpiar los existentes
      if (this.waypointsMarkers.length > 0) {
        this.waypointsMarkers.forEach((marker) => {
          marker.map = null;
        });
      }
      if (this.markers.length > 0) {
        this.markers.forEach((marker) => {
          marker.map = null;
        });
      }
      this.waypointsMarkers = [];
      //Seteo los valores de los marcadores
      await this.setMarkers(trips);

      const centerMap = await this.prepareMapView();

      this.map.setCenter(centerMap);
      this.map.setZoom(11);

      let bounds = new gapi.maps.LatLngBounds();
      this.markers.forEach((marker) => {
        let loc = new gapi.maps.LatLng(marker.position.lat, marker.position.lng);
        bounds.extend(loc);
      });
      this.map.fitBounds(bounds);

      const requireIcon = false;
      const configStroke = {
        strokeColor: '#AD20CE',
        strokeOpacity: 0.8,
        strokeWeight: widthLine,
      };
      this.markers[0].waypoints = waypoints;
      this.preparePathInMapGoogle(this.markers, this.markers[0], 0, requireIcon, configStroke);
      this.markers[0].waypoints.forEach(async (wp, idx) => {
        const waypointId = Date.now() + Math.random();
        wp.id = waypointId;
        const marker = await this.prepareMarker(
          idx,
          wp.location.lat,
          wp.location.lng,
          'waypoint',
          'Waypoint',
          null,
          '#FFFFFF',
          edit,
        );
        marker._waypointId = waypointId; // Asocia el id al marcador
        this.waypointsMarkers.push(marker);
        if (edit) {
          this.setDinamicWaypoints(marker, requireIcon, configStroke);
        }
      });

      // Para agregar un nuevo waypoint con click en el mapa
      if (edit) {
        this.map.addListener('click', async (event) => {
          const waypointId = Date.now() + Math.random();
          this.markers[0].waypoints.push({
            id: waypointId,
            location: { lat: event.latLng.lat(), lng: event.latLng.lng() },
          });
          const marker = await this.prepareMarker(
            waypointId,
            event.latLng.lat(),
            event.latLng.lng(),
            'waypoint',
            'Waypoint',
            null,
            '#FFFFFF',
            edit,
          );
          console.log('crearWaypoint');
          marker._waypointId = waypointId; // Asocia el id al marcador
          this.waypointsMarkers.push(marker);
          //Como se añade un nuevo waypoint entonces se utiliza el ultimo indice del listado para acceder a el
          this.setDinamicWaypoints(marker, requireIcon, configStroke);
          this.preparePathInMapGoogle(this.markers, this.markers[0], 0, requireIcon, configStroke);
        });
      }
    },
    setDinamicWaypoints(marker, requireIcon, configStroke) {
      marker.addListener('dragend', (event) => {
        const wp = this.markers[0].waypoints.find((wp) => wp.id === marker._waypointId);
        if (wp) {
          wp.location.lat = event.latLng.lat();
          wp.location.lng = event.latLng.lng();
          this.preparePathInMapGoogle(this.markers, this.markers[0], 0, requireIcon, configStroke);
        }
      });
      // Puedes agregar aquí lógica para eliminar el waypoint (por ejemplo, con click derecho)
      marker.addListener('click', () => {
        console.log('Tratando de borrar el amrker');
        marker.map = null;
        // Elimina el marcador del array
        const markerIdx = this.waypointsMarkers.indexOf(marker);
        if (markerIdx > -1) {
          this.waypointsMarkers.splice(markerIdx, 1);
        }
        // Elimina el waypoint usando el id
        if (Array.isArray(this.markers[0].waypoints)) {
          const wpIdx = this.markers[0].waypoints.findIndex((wp) => wp.id === marker._waypointId);
          if (wpIdx > -1) {
            this.markers[0].waypoints.splice(wpIdx, 1);
          }
        }
        this.preparePathInMapGoogle(this.markers, this.markers[0], 0, requireIcon, configStroke);
        marker.map = null;
      });
    },
    makePolygonGeofence(markers, gapi, zone, name) {
      let zonesFormat = [];
      zone.forEach((point) => {
        zonesFormat.push({
          lat: point.lat,
          lng: point.lon,
        });
      });
      const polygonZone = new gapi.maps.Polygon({
        paths: zonesFormat,
        strokeColor: 'rgba(98, 38, 247, 1)',
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: 'rgba(98, 38, 247, 1)',
        fillOpacity: 0.35,
        map: this.map,
      });
      this.geoFencePoints.push(polygonZone);

      const colorIcon = '#6226f7';
      const indexMarker = 1;
      const tempObject = this.buildMarker(
        0,
        indexMarker,
        name,
        'geofence',
        zone[0].lat,
        zone[0].lon,
        colorIcon,
        false,
        null,
      );
      markers.push(tempObject);
    },
    /*
    async addRealTimeMarkers(gapi, vehiclePoints, requireZoom) {
      this.usingVehicleMarker = true;
      //Se encarga de limpiar el cluster si es que existe
      this.cleanCluster();
      //Limpio marcadores de google
      this.cleanMapMarkers();
      //Limpio el spiderfier
      this.cleanMarkersFromSpiderfier();
      //Limpio rendereizados en el mapa
      this.setMapNull();
      this.configureSpiderfier();
      vehiclePoints.forEach((vehicle, index) => {
        const indexMarker = index + 1;
        const name = vehicle.plate;
        const lat = vehicle.lat;
        const lon = vehicle.lon;
        const hasRealLocation = false;
        //Si el marcador es bodega se pasa nulo debido a que el marcador es una imagen para las bodegas
        const colorIcon = this.markerColor(vehicle);
        const vehicleMarker = this.prepareMarker(indexMarker, lat, lon, name, 'Vehicle', vehicle.state, colorIcon);
        this.setInfoContent(indexMarker, vehicleMarker, 'Vehicle', colorIcon);
        const svgMarker = this.setSvgMarker(
          initMarker,
          colorIcon,
          indexMarker,
          'Vehicle',
          vehicle.gpsData.cog,
          vehicle.state,
        );

        this.vehiclePositionMarker.push(vehicleMarker);
      });

      //Por cada viaje, se prepara un marker en mapa.
      if (this.vehiclePositionMarker.length >= 1) {
        this.oms.clearMarkers();
        let bounds = new gapi.maps.LatLngBounds();
        this.vehiclePositionMarker.forEach((marker) => {
          marker.setMap(this.map);
          const loc = new gapi.maps.LatLng(marker.position.lat(), marker.position.lng());
          this.oms.addMarker(marker);
          bounds.extend(loc);
        });
        if (requireZoom) {
          await this.$refs.mapRef.$mapPromise.then((map) => {
            map.fitBounds(bounds);
          });
        }
      }
      const customRenderer = {
        render: ({ count, position }) => {
          return new this.gapi.maps.Marker({
            label: { text: String(count), color: 'white', fontSize: '10px' },
            position,
            // adjust zIndex to be above other markers
            zIndex: Number(this.gapi.maps.Marker.MAX_ZINDEX) + count,
            icon: {
              url: require('../assets/cluster.svg'),
            },
          });
        },
      };
      this.markerCluster = new MarkerClusterer({
        markers: this.vehiclePositionMarker,
        map: this.map,
        renderer: customRenderer,
      });
    },*/
    /**
     * Metodo que configura el Spiderfier, esto es la araña que permite visualizar marcadores solapados
     */
    configureSpiderfier() {
      const options = {
        keepSpiderfied: true,
        markersWontMove: true,
        markersWontHide: true,
        basicFormatEvents: true,
        minZoomLevel: 7,
        nudgeRadius: 0.004,
        nearbyDistance: 1,
        legWeight: 5,
        circleFootSeparation: 30,
      };
      const Spiderfier = require('overlapping-marker-spiderfier');
      this.oms = new Spiderfier(this.map, options);
      const iw = new this.gapi.maps.InfoWindow();
      this.oms.addListener('click', (marker) => {
        this.currentInfoWindow = iw;
        iw.setContent(marker.description);
        iw.open(document.getElementById('mapGoogle'), marker);
      });
      this.oms.addListener('spiderfy', () => {
        this.currentInfoWindow = null;
        iw.close();
      });
    },
    prepareMapViewGoogle(markersList) {
      if (markersList.length === 1) {
        // Si el mapa solo tiene un punto, se retorna la posición de dicho punto.
        return markersList[0].position;
      } else if (markersList.length === 2) {
        // Si el mapa tiene 2 puntos, se retorna el punto medio entre ambas.
        return {
          lat: (markersList[0].position.lat + markersList[1].position.lat) / 2,
          lng: (markersList[0].position.lng + markersList[1].position.lng) / 2,
        };
      } else {
        // Si el mapa tiene 3 o más puntos, se realiza el cálculo con MIN y MAX.
        let latLowest = Infinity;
        let latHighest = -Infinity;
        let lngLowest = Infinity;
        let lngHighest = -Infinity;

        markersList.forEach((marker) => {
          const lat = marker.position.lat;
          const lng = marker.position.lng;
          if (lat < latLowest) latLowest = lat;
          if (lat > latHighest) latHighest = lat;
          if (lng < lngLowest) lngLowest = lng;
          if (lng > lngHighest) lngHighest = lng;
        });

        return {
          lat: latLowest + (latHighest - latLowest) / 2,
          lng: lngLowest + (lngHighest - lngLowest) / 2,
        };
      }
    },
    /**
     * Metodo que prepara los listados de marcadores y el listado de puntos para trazar las rutas en el mapa
     * @param {Array} listOfData //Array de ubicaciones proveniente del consumidor
     * @param {Global Array} globalMarkers //Array de alguna variable global pasada
     * @param {Array} pointsRender //Array de puntos para el trazado de la ruta
     * @param {Boolean} isTripMarker //Flag para saber si son trips o bodegas
     * @param {Integer} i //Indice
     * @returns
     */
    createMarkers(listOfData, globalMarkers, pointsRender, markerType, i) {
      let waypList = [];
      listOfData.forEach((activity, index) => {
        if (activity.index === i && activity.spot != null) {
          const indexMarker = markerType == 'Trip' ? activity.subIndex + 1 : 0;
          const name = markerType == 'Trip' ? activity.name : 'Base';
          //const street =
          activity.spot.address.street + ', ' + activity.spot.address.city + ', ' + activity.spot.address.state;
          const lat = activity.spot.address.lat;
          const lon = activity.spot.address.lon;
          //let realLocation = null;
          ///Si la actividad posee datos de lat y lon significa que posee ubicación real de ejecución
          /*if (activity.lat !== undefined && activity.lat !== 0 && activity.lon !== undefined && activity.lon !== 0) {
            realLocation = {
              lat: activity.lat,
              lon: activity.lon,
            };
          }*/
          //const hasRealLocation = realLocation != null ? true : false;
          //Si el marcador es bodega se pasa nulo debido a que el marcador es una imagen para las bodegas
          let colorIcon = markerType == 'Trip' ? this.markerColor(activity) : null;
          //const type = activity.type != undefined ? activity.type : null;

          const initMarker = this.prepareMarker(indexMarker, lat, lon, name, markerType, null, colorIcon);
          globalMarkers.push(initMarker);
          const lengthArray = listOfData.length - 1;
          pointsRender = this.preparePointsForDrawing(
            waypList,
            pointsRender,
            markerType,
            lat,
            lon,
            initMarker,
            lengthArray,
            index,
          );
        }
      });
      return pointsRender;
    },
    preparePointsForDrawing(waypList, pointsRender, isTripMarker, lat, lon, svgMarker, lengthArray, index) {
      if (isTripMarker == 'Trip') {
        //Mientras aun no tenga 10 registros en el array seguire insertando
        if (waypList.length < 10) {
          const waypoint = {
            location: {
              lat: lat,
              lng: lon,
            },
            stopover: true,
          };
          waypList.push(waypoint);
        }
        //Si el array de waypoints es igual a 10 o si el iterador alcanzo el tamaño del array
        //Se setean todos los waypoints capturados al ultimo punto del array para el trazado de rutas, y se limpia el array
        if (waypList.length == 10 || index == lengthArray) {
          pointsRender[pointsRender.length - 1]['waypoints'] = waypList;
          pointsRender.push(svgMarker);
          waypList = [];
        }
      } else {
        pointsRender.push(svgMarker);
      }
      return pointsRender;
    },
    async setEvents(events) {
      if (events && events.length > 0) {
        const colorEvent = '#D92D20';
        for (let i = 0; i < events.length; i++) {
          const event = events[i];
          const marker = await this.prepareMarker(
            100 + i,
            event.latitude,
            event.longitude,
            event.nameEvent,
            'Event',
            event.eventType,
            colorEvent,
          );
          marker.event = event; // Asocia el evento al marcador para usarlo en el info window
          this.eventMarkers.push(marker);
          this.setInfoContent(100 + i, marker, 'Event', colorEvent, true);
        }
      }
    },
    async prepareMarker(indexMarker, lat, lon, name, markerType, state, colorIcon, draggable = false) {
      // Construcción del icono usando PinElement
      let pin;
      if (markerType === 'Waypoint') {
        const parser = new DOMParser();
        const svg = `<svg width="13" height="13" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="7" cy="7" r="6.5" fill="#F6F8F5" stroke="#030004"/>
        </svg>`;
        pin = parser.parseFromString(svg, 'image/svg+xml').documentElement;
      } else if (markerType === 'Trip') {
        pin = this.buildPin({
          color: colorIcon,
          text: indexMarker,
        });
      } else if (markerType === 'Depot') {
        pin = this.buildPin({
          color: colorIcon,
          icon: require('../assets/depot.svg'),
        });
      } else if (markerType === 'Vehicle') {
        const parser = new DOMParser();
        const svg =
          state === 'ACTIVE'
            ? `<svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="17.5324" cy="17.5325" r="17.3198" transform="rotate(-89.2922 17.5324 17.5325)" fill="#8540FF" fill-opacity="0.2"/>
          <circle cx="17.5314" cy="17.5324" r="13.5409" transform="rotate(-89.2922 17.5314 17.5324)" fill="#9258F9"/>
          <path d="M24.1511 11.8838C23.9733 11.3675 23.4756 11 22.8889 11L13.1111 11C12.5244 11 12.0356 11.3675 11.8489 11.8838L10.0978 16.845C10.0356 17.0288 10 17.2213 10 17.4225L10 23.6875C10 24.4137 10.5956 25 11.3333 25C12.0711 25 12.6667 24.4137 12.6667 23.6875L12.6667 23.25L23.3333 23.25L23.3333 23.6875C23.3333 24.405 23.9289 25 24.6667 25C25.3956 25 26 24.4137 26 23.6875L26 17.4225C26 17.23 25.9644 17.0288 25.9022 16.845L24.1511 11.8838ZM13.1111 20.625C12.3733 20.625 11.7778 20.0387 11.7778 19.3125C11.7778 18.5862 12.3733 18 13.1111 18C13.8489 18 14.4444 18.5862 14.4444 19.3125C14.4444 20.0387 13.8489 20.625 13.1111 20.625ZM22.8889 20.625C22.1511 20.625 21.5556 20.0387 21.5556 19.3125C21.5556 18.5862 22.1511 18 22.8889 18C23.6267 18 24.2222 18.5862 24.2222 19.3125C24.2222 20.0387 23.6267 20.625 22.8889 20.625ZM11.7778 16.25L12.9067 12.9075C13.0311 12.5575 13.3689 12.3125 13.7511 12.3125L22.2489 12.3125C22.6311 12.3125 22.9689 12.5575 23.0933 12.9075L24.2222 16.25L11.7778 16.25Z" fill="white"/>
          </svg>`
            : `<svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="21.6404" cy="21.6404" r="17.3198" transform="rotate(-17.0676 21.6404 21.6404)" fill="#4A4A4A" fill-opacity="0.4"/>
          <circle cx="21.6395" cy="21.6403" r="13.5409" transform="rotate(-17.0676 21.6395 21.6403)" fill="#5B5B5B"/>
          <path d="M28.1492 14.8838C27.9714 14.3675 27.4736 14 26.8869 14L17.1092 14C16.5225 14 16.0336 14.3675 15.8469 14.8838L14.0958 19.845C14.0336 20.0288 13.998 20.2213 13.998 20.4225L13.998 26.6875C13.998 27.4137 14.5936 28 15.3314 28C16.0692 28 16.6647 27.4137 16.6647 26.6875L16.6647 26.25L27.3314 26.25L27.3314 26.6875C27.3314 27.405 27.9269 28 28.6647 28C29.3936 28 29.998 27.4137 29.998 26.6875L29.998 20.4225C29.998 20.23 29.9625 20.0288 29.9003 19.845L28.1492 14.8838ZM17.1092 23.625C16.3714 23.625 15.7758 23.0387 15.7758 22.3125C15.7758 21.5862 16.3714 21 17.1092 21C17.8469 21 18.4425 21.5862 18.4425 22.3125C18.4425 23.0387 17.8469 23.625 17.1092 23.625ZM26.8869 23.625C26.1492 23.625 25.5536 23.0387 25.5536 22.3125C25.5536 21.5862 26.1492 21 26.8869 21C27.6247 21 28.2203 21.5862 28.2203 22.3125C28.2203 23.0387 27.6247 23.625 26.8869 23.625ZM15.7758 19.25L16.9047 15.9075C17.0292 15.5575 17.3669 15.3125 17.7492 15.3125L26.2469 15.3125C26.6292 15.3125 26.9669 15.5575 27.0914 15.9075L28.2203 19.25L15.7758 19.25Z" fill="white"/>
          </svg>`;
        pin = parser.parseFromString(svg, 'image/svg+xml').documentElement;
      } else if (markerType === 'Event') {
        //En este caso el state se pasa como un tipo de alerta
        pin = this.buildPinEvent(state, colorIcon);
      } else {
        pin = this.buildPin({ color: colorIcon });
      }
      // Crea el marcador avanzado
      const marker = new this.gapi.maps.marker.AdvancedMarkerElement({
        position: { lat: lat, lng: lon },
        map: this.map,
        title: name,
        zIndex: parseInt(indexMarker, 10),
        gmpDraggable: draggable,
        gmpClickable: true,
      });
      marker.index = indexMarker;
      marker.append(pin);
      // Puedes guardar info extra en el marker si lo necesitas
      //marker.description = content;
      return marker;
    },
    centerAndOpenInfoWindow(eventId) {
      const marker = this.eventMarkers.find((m) => m.event.eventId === eventId);
      if (!marker || !this.map) return;
      // Centra el mapa en el marcador
      const pos = this._getLatLngFromMarker(marker);
      this.map.setCenter(pos);
      this.map.setZoom(17); // Opcional: ajusta el zoom si lo deseas

      // Abre el InfoWindow del marcador
      if (marker._infoWindow) {
        if (this.currentInfoWindow) {
          this.currentInfoWindow.close();
        }
        if (this.zoneInfoWindow) {
          this.zoneInfoWindow.close();
        }
        marker._infoWindow.open(this.map, marker);
        this.currentInfoWindow = marker._infoWindow;
        this.currentInfoWindow.eventId = marker?.event?.eventId;
      }
    },
    buildPinEvent(eventType, colorIcon) {
      let pin;
      if (eventType == EVENT.APERTURA_PUERTA) {
        pin = this.buildPin({
          color: colorIcon,
          icon: require('../assets/events/aperturaPuertas.svg'),
        });
      } else if (eventType == EVENT.DETENCION_EXCESIVA) {
        pin = this.buildPin({
          color: colorIcon,
          icon: require('../assets/events/detencionExcesiva.svg'),
        });
      } else if (eventType == EVENT.EXCESO_VELOCIDAD) {
        pin = this.buildPin({
          color: colorIcon,
          icon: require('../assets/events/excesoVelocidad.svg'),
        });
      } else if (eventType == EVENT.EXCESO_VELOCIDAD_FLOTA) {
        pin = this.buildPin({
          color: colorIcon,
          icon: require('../assets/events/excesoVelocidadFlota.svg'),
        });
      } else if (eventType == EVENT.DESCONEXION_ELECTRICA) {
        pin = this.buildPin({
          color: colorIcon,
          icon: require('../assets/events/desconexionElectrica.svg'),
        });
      } else if (eventType == EVENT.PERDIDA_UBICACION_GPS) {
        pin = this.buildPin({
          color: colorIcon,
          icon: require('../assets/events/perdidaUbicacionGps.svg'),
        });
      } else if (eventType == EVENT.SALIDA_RUTA) {
        pin = this.buildPin({
          color: colorIcon,
          icon: require('../assets/events/salidaRuta.svg'),
        });
      } else if (eventType == EVENT.INTEREFERENCIA_GPS) {
        pin = this.buildPin({
          color: colorIcon,
          icon: require('../assets/events/interferenciaGps.svg'),
        });
      } else if (eventType == EVENT.BOTON_PANICO) {
        pin = this.buildPin({
          color: colorIcon,
          icon: require('../assets/events/botonPanico.svg'),
        });
      }
      return pin;
    },
    chooseIcon(eventType, color) {
      let icon;
      switch (eventType) {
        case 101:
          icon = `
          <span style="background: #fff; color: #fff;border: 3px solid ${color}; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-weight: bold;">
          <svg width="12" height="14" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.16667 12.5C3.93056 12.5 3.73264 12.4201 3.57292 12.2604C3.41319 12.1007 3.33333 11.9028 3.33333 11.6667C3.33333 11.4306 3.41319 11.2326 3.57292 11.0729C3.73264 10.9132 3.93056 10.8333 4.16667 10.8333C4.40278 10.8333 4.60069 10.9132 4.76042 11.0729C4.92014 11.2326 5 11.4306 5 11.6667C5 11.9028 4.92014 12.1007 4.76042 12.2604C4.60069 12.4201 4.40278 12.5 4.16667 12.5ZM4.16667 16.6667C3.01389 16.6667 2.03125 16.2604 1.21875 15.4479C0.40625 14.6354 0 13.6528 0 12.5V4.16667C0 3.01389 0.40625 2.03125 1.21875 1.21875C2.03125 0.40625 3.01389 0 4.16667 0C5.31944 0 6.30208 0.40625 7.11458 1.21875C7.92708 2.03125 8.33333 3.01389 8.33333 4.16667V12.5C8.33333 13.6528 7.92708 14.6354 7.11458 15.4479C6.30208 16.2604 5.31944 16.6667 4.16667 16.6667ZM4.16667 13.3333C4.625 13.3333 5.01736 13.1701 5.34375 12.8437C5.67014 12.5174 5.83333 12.125 5.83333 11.6667C5.83333 11.2083 5.67014 10.816 5.34375 10.4896C5.01736 10.1632 4.625 10 4.16667 10C3.70833 10 3.31597 10.1632 2.98958 10.4896C2.66319 10.816 2.5 11.2083 2.5 11.6667C2.5 12.125 2.66319 12.5174 2.98958 12.8437C3.31597 13.1701 3.70833 13.3333 4.16667 13.3333ZM4.16667 6.66667C4.625 6.66667 5.01736 6.50347 5.34375 6.17708C5.67014 5.85069 5.83333 5.45833 5.83333 5C5.83333 4.54167 5.67014 4.14931 5.34375 3.82292C5.01736 3.49653 4.625 3.33333 4.16667 3.33333C3.70833 3.33333 3.31597 3.49653 2.98958 3.82292C2.66319 4.14931 2.5 4.54167 2.5 5C2.5 5.45833 2.66319 5.85069 2.98958 6.17708C3.31597 6.50347 3.70833 6.66667 4.16667 6.66667ZM9.72917 10.8333C9.49306 10.8333 9.29514 10.7535 9.13542 10.5937C8.97569 10.434 8.89583 10.2361 8.89583 10C8.89583 9.88889 8.91667 9.78125 8.95833 9.67708C9 9.57292 9.05556 9.48611 9.125 9.41667C9.27778 9.26389 9.39236 9.09722 9.46875 8.91667C9.54514 8.73611 9.58333 8.54167 9.58333 8.33333C9.58333 8.125 9.54514 7.93055 9.46875 7.75C9.39236 7.56944 9.27778 7.40278 9.125 7.25C9.05556 7.16667 9 7.07639 8.95833 6.97917C8.91667 6.88194 8.89583 6.77778 8.89583 6.66667C8.89583 6.43056 8.97569 6.23264 9.13542 6.07292C9.29514 5.91319 9.49306 5.83333 9.72917 5.83333C9.84028 5.83333 9.94792 5.85764 10.0521 5.90625C10.1562 5.95486 10.2431 6.01389 10.3125 6.08333C10.6181 6.38889 10.8507 6.73264 11.0104 7.11458C11.1701 7.49653 11.25 7.90278 11.25 8.33333C11.25 8.76389 11.1701 9.17014 11.0104 9.55208C10.8507 9.93403 10.6181 10.2778 10.3125 10.5833C10.2431 10.6528 10.1562 10.7118 10.0521 10.7604C9.94792 10.809 9.84028 10.8333 9.72917 10.8333ZM11.9583 12.5C11.7222 12.5 11.5243 12.4201 11.3646 12.2604C11.2049 12.1007 11.125 11.9028 11.125 11.6667C11.125 11.5556 11.1493 11.4479 11.1979 11.3437C11.2465 11.2396 11.3056 11.1528 11.375 11.0833C11.7361 10.7222 12.0139 10.3021 12.2083 9.82292C12.4028 9.34375 12.5 8.84722 12.5 8.33333C12.5 7.81944 12.4028 7.32292 12.2083 6.84375C12.0139 6.36458 11.7361 5.94444 11.375 5.58333C11.3056 5.51389 11.2465 5.42708 11.1979 5.32292C11.1493 5.21875 11.125 5.11111 11.125 5C11.125 4.76389 11.2049 4.56597 11.3646 4.40625C11.5243 4.24653 11.7222 4.16667 11.9583 4.16667C12.0694 4.16667 12.1771 4.19097 12.2812 4.23958C12.3854 4.28819 12.4722 4.34722 12.5417 4.41667C13.0694 4.94444 13.4722 5.54167 13.75 6.20833C14.0278 6.875 14.1667 7.58333 14.1667 8.33333C14.1667 9.08333 14.0278 9.79167 13.75 10.4583C13.4722 11.125 13.0694 11.7222 12.5417 12.25C12.4722 12.3194 12.3854 12.3785 12.2812 12.4271C12.1771 12.4757 12.0694 12.5 11.9583 12.5Z" fill=${color}>
          </svg>
          </span>`;
          break;
        case 102:
          icon = `<span style="background: #fff; color: #fff;border: 3px solid ${color}; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-weight: bold;">
          <svg width="14" height="15" viewBox="0 0 15 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.83333 1.66667C5.59722 1.66667 5.39931 1.58681 5.23958 1.42708C5.07986 1.26736 5 1.06944 5 0.833333C5 0.597222 5.07986 0.399306 5.23958 0.239583C5.39931 0.0798611 5.59722 0 5.83333 0H9.16667C9.40278 0 9.60069 0.0798611 9.76042 0.239583C9.92014 0.399306 10 0.597222 10 0.833333C10 1.06944 9.92014 1.26736 9.76042 1.42708C9.60069 1.58681 9.40278 1.66667 9.16667 1.66667H5.83333ZM7.5 10.8333C7.73611 10.8333 7.93403 10.7535 8.09375 10.5938C8.25347 10.434 8.33333 10.2361 8.33333 10V6.66667C8.33333 6.43056 8.25347 6.23264 8.09375 6.07292C7.93403 5.91319 7.73611 5.83333 7.5 5.83333C7.26389 5.83333 7.06597 5.91319 6.90625 6.07292C6.74653 6.23264 6.66667 6.43056 6.66667 6.66667V10C6.66667 10.2361 6.74653 10.434 6.90625 10.5938C7.06597 10.7535 7.26389 10.8333 7.5 10.8333ZM7.5 17.5C6.47222 17.5 5.50347 17.3021 4.59375 16.9062C3.68403 16.5104 2.88889 15.9722 2.20833 15.2917C1.52778 14.6111 0.989583 13.816 0.59375 12.9062C0.197917 11.9965 0 11.0278 0 10C0 8.97222 0.197917 8.00347 0.59375 7.09375C0.989583 6.18403 1.52778 5.38889 2.20833 4.70833C2.88889 4.02778 3.68403 3.48958 4.59375 3.09375C5.50347 2.69792 6.47222 2.5 7.5 2.5C8.36111 2.5 9.1875 2.63889 9.97917 2.91667C10.7708 3.19444 11.5139 3.59722 12.2083 4.125L12.7917 3.54167C12.9444 3.38889 13.1389 3.3125 13.375 3.3125C13.6111 3.3125 13.8056 3.38889 13.9583 3.54167C14.1111 3.69444 14.1875 3.88889 14.1875 4.125C14.1875 4.36111 14.1111 4.55556 13.9583 4.70833L13.375 5.29167C13.9028 5.98611 14.3056 6.72917 14.5833 7.52083C14.8611 8.3125 15 9.13889 15 10C15 11.0278 14.8021 11.9965 14.4062 12.9062C14.0104 13.816 13.4722 14.6111 12.7917 15.2917C12.1111 15.9722 11.316 16.5104 10.4062 16.9062C9.49653 17.3021 8.52778 17.5 7.5 17.5Z" fill=${color}>
          </svg>
          </span>`;
          break;
        case 103:
          icon = `<span style="background: #fff; color: #fff;border: 3px solid ${color}; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-weight: bold;">
          <svg width="16" height="13" viewBox="0 0 17 14" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7.04167 9.58333C7.38889 9.93056 7.82639 10.0937 8.35417 10.0729C8.88194 10.0521 9.26389 9.86111 9.5 9.5L13.0208 4.22917C13.1458 4.03472 13.1285 3.85764 12.9688 3.69792C12.809 3.53819 12.6319 3.52083 12.4375 3.64583L7.16667 7.16667C6.80556 7.41667 6.60764 7.79514 6.57292 8.30208C6.53819 8.80903 6.69444 9.23611 7.04167 9.58333ZM2.58333 13.3333C2.27778 13.3333 1.99653 13.2674 1.73958 13.1354C1.48264 13.0035 1.27778 12.8056 1.125 12.5417C0.763889 11.8889 0.486111 11.2118 0.291667 10.5104C0.0972222 9.80903 0 9.08333 0 8.33333C0 7.18056 0.21875 6.09722 0.65625 5.08333C1.09375 4.06944 1.6875 3.1875 2.4375 2.4375C3.1875 1.6875 4.06944 1.09375 5.08333 0.65625C6.09722 0.21875 7.18056 0 8.33333 0C9.47222 0 10.5417 0.215278 11.5417 0.645833C12.5417 1.07639 13.4167 1.66319 14.1667 2.40625C14.9167 3.14931 15.5139 4.01736 15.9583 5.01042C16.4028 6.00347 16.6319 7.06944 16.6458 8.20833C16.6597 8.97222 16.5729 9.71875 16.3854 10.4479C16.1979 11.1771 15.9097 11.875 15.5208 12.5417C15.3681 12.8056 15.1632 13.0035 14.9062 13.1354C14.6493 13.2674 14.3681 13.3333 14.0625 13.3333H2.58333Z" fill=${color}>
          </svg>
          </span>`;
          break;
        case 104:
          icon = `<span style="background: #fff; color: #fff;border: 3px solid ${color}; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-weight: bold;">
          <svg width="15" height="14" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2.125 13.4583V13.8125C2.125 14.1076 2.0217 14.3585 1.8151 14.5651C1.60851 14.7717 1.35764 14.875 1.0625 14.875C0.767361 14.875 0.516493 14.7717 0.309896 14.5651C0.103299 14.3585 0 14.1076 0 13.8125V8.925C0 8.78333 0.0118056 8.64462 0.0354167 8.50885C0.0590278 8.37309 0.100347 8.24028 0.159375 8.11042L1.50521 4.90521C1.58785 4.70451 1.71771 4.54514 1.89479 4.42708C2.07188 4.30903 2.26667 4.25 2.47917 4.25H8.85417C9.06667 4.25 9.26146 4.30903 9.43854 4.42708C9.61563 4.54514 9.74549 4.70451 9.82813 4.90521L11.174 8.11042C11.233 8.24028 11.2743 8.37309 11.2979 8.50885C11.3215 8.64462 11.3333 8.78333 11.3333 8.925V13.8125C11.3333 14.1076 11.23 14.3585 11.0234 14.5651C10.8168 14.7717 10.566 14.875 10.2708 14.875C9.9757 14.875 9.72483 14.7717 9.51823 14.5651C9.31163 14.3585 9.20833 14.1076 9.20833 13.8125V13.4583H2.125ZM1.98333 7.08333H9.33229L8.74792 5.66667H2.58542L1.98333 7.08333ZM3.1875 11.3333C3.48264 11.3333 3.73351 11.23 3.9401 11.0234C4.1467 10.8168 4.25 10.566 4.25 10.2708C4.25 9.97569 4.1467 9.72483 3.9401 9.51823C3.73351 9.31163 3.48264 9.20833 3.1875 9.20833C2.89236 9.20833 2.64149 9.31163 2.4349 9.51823C2.2283 9.72483 2.125 9.97569 2.125 10.2708C2.125 10.566 2.2283 10.8168 2.4349 11.0234C2.64149 11.23 2.89236 11.3333 3.1875 11.3333ZM8.14583 11.3333C8.44097 11.3333 8.69184 11.23 8.89844 11.0234C9.10504 10.8168 9.20833 10.566 9.20833 10.2708C9.20833 9.97569 9.10504 9.72483 8.89844 9.51823C8.69184 9.31163 8.44097 9.20833 8.14583 9.20833C7.8507 9.20833 7.59983 9.31163 7.39323 9.51823C7.18663 9.72483 7.08333 9.97569 7.08333 10.2708C7.08333 10.566 7.18663 10.8168 7.39323 11.0234C7.59983 11.23 7.8507 11.3333 8.14583 11.3333ZM10.749 3.54167H4.37396C4.13785 3.54167 3.96076 3.46788 3.84271 3.32031C3.72465 3.17274 3.66563 3.01042 3.66563 2.83333C3.66563 2.65625 3.72465 2.49392 3.84271 2.34635C3.96076 2.19878 4.13785 2.125 4.37396 2.125H10.9792C11.1917 2.125 11.3865 2.18403 11.5635 2.30208C11.7406 2.42014 11.8705 2.57951 11.9531 2.78021L13.299 5.98542C13.358 6.11528 13.3993 6.24809 13.4229 6.38385C13.4465 6.51962 13.4583 6.65833 13.4583 6.8V12.0417C13.4583 12.2424 13.3905 12.4106 13.2547 12.5464C13.1189 12.6821 12.9507 12.75 12.75 12.75C12.5493 12.75 12.3811 12.6821 12.2453 12.5464C12.1095 12.4106 12.0417 12.2424 12.0417 12.0417V6.65833L10.749 3.54167ZM12.874 1.41667H6.49896C6.26285 1.41667 6.08576 1.34288 5.96771 1.19531C5.84965 1.04774 5.79063 0.885417 5.79063 0.708333C5.79063 0.53125 5.84965 0.368924 5.96771 0.221354C6.08576 0.0737847 6.26285 0 6.49896 0H13.1042C13.3167 0 13.5115 0.0590278 13.6885 0.177083C13.8656 0.295139 13.9955 0.454514 14.0781 0.655208L15.424 3.86042C15.483 3.99028 15.5243 4.12309 15.5479 4.25885C15.5715 4.39462 15.5833 4.53333 15.5833 4.675V9.91667C15.5833 10.1174 15.5155 10.2856 15.3797 10.4214C15.2439 10.5571 15.0757 10.625 14.875 10.625C14.6743 10.625 14.5061 10.5571 14.3703 10.4214C14.2346 10.2856 14.1667 10.1174 14.1667 9.91667V4.53333L12.874 1.41667Z" fill=${color}>
          </svg>
          </span>`;
          break;
        case 105:
          icon = `<span style="background: #fff; color: #fff;border: 3px solid ${color}; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-weight: bold;">
          <svg width="13" height="13" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.40897 13.1421C6.19965 13.1421 6.02419 13.0721 5.88259 12.9322C5.74099 12.7923 5.67019 12.6189 5.67019 12.412V10.9518L3.50923 8.81617C3.37379 8.68231 3.26913 8.52716 3.19525 8.35072C3.12137 8.17427 3.08443 7.9887 3.08443 7.794V4.3807C3.08443 4.08866 3.15215 3.81486 3.2876 3.55932C3.42304 3.30378 3.62005 3.10908 3.87863 2.97523V5.01956L0.203166 1.38722C0.0677221 1.25337 0 1.08301 0 0.876141C0 0.669274 0.0677221 0.498914 0.203166 0.365059C0.33861 0.231204 0.510994 0.164276 0.720317 0.164276C0.929639 0.164276 1.10202 0.231204 1.23747 0.365059L13.7968 12.7771C13.9323 12.9109 14 13.0813 14 13.2881C14 13.495 13.9323 13.6654 13.7968 13.7992C13.6614 13.9331 13.489 14 13.2797 14C13.0704 14 12.898 13.9331 12.7625 13.7992L9.62269 10.6962L9.36412 10.9518V12.412C9.36412 12.6189 9.29332 12.7923 9.15172 12.9322C9.01011 13.0721 8.83465 13.1421 8.62533 13.1421H6.40897ZM11.3219 8.25033L4.56201 1.56975V0.730117C4.56201 0.523251 4.63281 0.349848 4.77441 0.209909C4.91601 0.0699696 5.09147 0 5.30079 0C5.51011 0 5.68558 0.0699696 5.82718 0.209909C5.96878 0.349848 6.03958 0.523251 6.03958 0.730117V2.92047H8.99472V0.730117C8.99472 0.523251 9.06552 0.349848 9.20712 0.209909C9.34873 0.0699696 9.52419 0 9.73351 0C9.94283 0 10.1183 0.0699696 10.2599 0.209909C10.4015 0.349848 10.4723 0.523251 10.4723 0.730117V3.65059L9.73351 2.92047H10.4723C10.8786 2.92047 11.2265 3.06345 11.5158 3.34941C11.8052 3.63538 11.9499 3.97914 11.9499 4.3807V7.02738C11.9499 7.22208 11.9129 7.40765 11.8391 7.58409C11.7652 7.76054 11.6605 7.91569 11.5251 8.04954L11.3219 8.25033Z" fill=${color}>
          </svg>
          </span>`;
          break;
        case 106:
          icon = `<span style="background: #fff; color: #fff;border: 3px solid ${color}; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-weight: bold;">
          <svg width="16" height="16" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M10.0625 16.3132C9.8125 16.3687 9.59375 16.3166 9.40625 16.1569C9.21875 15.9972 9.125 15.7785 9.125 15.5007C9.125 15.3062 9.19097 15.1291 9.32292 14.9694C9.45486 14.8097 9.61806 14.7021 9.8125 14.6465C10.1597 14.5632 10.4965 14.4555 10.8229 14.3236C11.1493 14.1916 11.4653 14.0285 11.7708 13.834C11.9514 13.7229 12.1493 13.6778 12.3646 13.6986C12.5799 13.7194 12.7569 13.7993 12.8958 13.9382C13.0903 14.1326 13.1771 14.3548 13.1562 14.6048C13.1354 14.8548 13.0139 15.0493 12.7917 15.1882C12.3611 15.466 11.9201 15.6951 11.4688 15.8757C11.0174 16.0562 10.5486 16.2021 10.0625 16.3132ZM14.0833 12.7507C13.9444 12.6118 13.8646 12.4382 13.8438 12.2298C13.8229 12.0215 13.8681 11.834 13.9792 11.6673C14.1597 11.3618 14.3194 11.0493 14.4583 10.7298C14.5972 10.4104 14.7083 10.0701 14.7917 9.70901C14.8472 9.51456 14.9583 9.3479 15.125 9.20901C15.2917 9.07012 15.4722 9.00067 15.6667 9.00067C15.9444 9.00067 16.1632 9.0979 16.3229 9.29234C16.4826 9.48678 16.5278 9.70901 16.4583 9.95901C16.3472 10.459 16.1979 10.9347 16.0104 11.3861C15.8229 11.8375 15.5903 12.2646 15.3125 12.6673C15.1736 12.8757 14.9826 12.9903 14.7396 13.0111C14.4965 13.0319 14.2778 12.9451 14.0833 12.7507ZM15.6458 7.33401C15.4514 7.33401 15.2743 7.26456 15.1146 7.12567C14.9549 6.98678 14.8472 6.82012 14.7917 6.62567C14.7083 6.26456 14.5972 5.92081 14.4583 5.59442C14.3194 5.26803 14.1597 4.95901 13.9792 4.66734C13.8681 4.50067 13.8229 4.31317 13.8438 4.10484C13.8646 3.89651 13.9444 3.72289 14.0833 3.58401C14.2778 3.38956 14.4965 3.29928 14.7396 3.31317C14.9826 3.32706 15.1736 3.43817 15.3125 3.64651C15.5903 4.04928 15.8264 4.48331 16.0208 4.94859C16.2153 5.41387 16.3681 5.88956 16.4792 6.37567C16.5347 6.62567 16.4792 6.8479 16.3125 7.04234C16.1458 7.23678 15.9236 7.33401 15.6458 7.33401ZM6.54167 16.2923C4.63889 15.8479 3.07292 14.8757 1.84375 13.3757C0.614583 11.8757 0 10.1396 0 8.16734C0 6.18123 0.611111 4.43123 1.83333 2.91734C3.05556 1.40345 4.61806 0.438172 6.52083 0.0215054C6.77083 -0.0340502 6.98958 0.0180332 7.17708 0.177755C7.36458 0.337478 7.45833 0.549283 7.45833 0.813172C7.45833 1.00762 7.39236 1.1847 7.26042 1.34442C7.12847 1.50414 6.96528 1.61178 6.77083 1.66734C5.28472 2.02845 4.0625 2.81317 3.10417 4.02151C2.14583 5.22984 1.66667 6.61178 1.66667 8.16734C1.66667 9.7229 2.14583 11.0944 3.10417 12.2819C4.0625 13.4694 5.28472 14.2576 6.77083 14.6465C6.96528 14.7021 7.12847 14.8132 7.26042 14.9798C7.39236 15.1465 7.45833 15.3271 7.45833 15.5215C7.45833 15.7854 7.36806 15.9937 7.1875 16.1465C7.00694 16.2993 6.79167 16.3479 6.54167 16.2923ZM11.8333 2.52151C11.5139 2.32706 11.1875 2.15692 10.8542 2.01109C10.5208 1.86526 10.1806 1.75067 9.83333 1.66734C9.63889 1.61178 9.47222 1.50414 9.33333 1.34442C9.19444 1.1847 9.125 1.00762 9.125 0.813172C9.125 0.549283 9.21875 0.337478 9.40625 0.177755C9.59375 0.0180332 9.8125 -0.0340502 10.0625 0.0215054C10.5486 0.132617 11.0208 0.27845 11.4792 0.459005C11.9375 0.639561 12.3819 0.868728 12.8125 1.14651C13.0347 1.28539 13.1562 1.47984 13.1771 1.72984C13.1979 1.97984 13.1111 2.20206 12.9167 2.39651C12.7778 2.53539 12.6076 2.61873 12.4062 2.64651C12.2049 2.67428 12.0139 2.63262 11.8333 2.52151ZM8.3125 12.0423C8.20139 12.0423 8.09375 12.025 7.98958 11.9903C7.88542 11.9555 7.79861 11.9035 7.72917 11.834C6.8125 10.9868 6.125 10.1951 5.66667 9.45901C5.20833 8.7229 4.97917 8.04234 4.97917 7.41734C4.97917 6.44512 5.29514 5.63262 5.92708 4.97984C6.55903 4.32706 7.35417 4.00067 8.3125 4.00067C9.27083 4.00067 10.066 4.32706 10.6979 4.97984C11.3299 5.63262 11.6458 6.44512 11.6458 7.41734C11.6458 8.04234 11.4167 8.7229 10.9583 9.45901C10.5 10.1951 9.8125 10.9868 8.89583 11.834C8.82639 11.9035 8.73958 11.9555 8.63542 11.9903C8.53125 12.025 8.42361 12.0423 8.3125 12.0423ZM8.3125 8.16734C8.5625 8.16734 8.77431 8.08053 8.94792 7.90692C9.12153 7.73331 9.20833 7.52151 9.20833 7.27151C9.20833 7.02151 9.12153 6.8097 8.94792 6.63609C8.77431 6.46248 8.5625 6.37567 8.3125 6.37567C8.0625 6.37567 7.85069 6.46248 7.67708 6.63609C7.50347 6.8097 7.41667 7.02151 7.41667 7.27151C7.41667 7.52151 7.50347 7.73331 7.67708 7.90692C7.85069 8.08053 8.0625 8.16734 8.3125 8.16734Z" fill=${color}>
          </svg>
          </span>`;
          break;
        case 107:
          icon = `<span style="background: #fff; color: #fff;border: 3px solid ${color}; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-weight: bold;">
          <svg width="12" height="15" viewBox="0 0 15 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.3125 15.4792V12.1458C6.3125 11.3681 6.19444 10.7917 5.95833 10.4167C5.72222 10.0417 5.40972 9.67361 5.02083 9.3125L6.20833 8.125C6.375 8.27778 6.53472 8.44097 6.6875 8.61458C6.84028 8.78819 6.99306 8.97222 7.14583 9.16667C7.34028 8.90278 7.53819 8.67014 7.73958 8.46875C7.94097 8.26736 8.14583 8.06944 8.35417 7.875C8.88194 7.38889 9.36111 6.82639 9.79167 6.1875C10.2222 5.54861 10.4514 4.43056 10.4792 2.83333L9.75 3.5625C9.59722 3.71528 9.40625 3.79167 9.17708 3.79167C8.94792 3.79167 8.75 3.71528 8.58333 3.5625C8.41667 3.39583 8.33333 3.19792 8.33333 2.96875C8.33333 2.73958 8.41667 2.54167 8.58333 2.375L10.7292 0.229167C10.8125 0.145833 10.9028 0.0868056 11 0.0520833C11.0972 0.0173611 11.2014 0 11.3125 0C11.4236 0 11.5278 0.0173611 11.625 0.0520833C11.7222 0.0868056 11.8125 0.145833 11.8958 0.229167L14.0625 2.39583C14.2153 2.54861 14.2951 2.73958 14.3021 2.96875C14.309 3.19792 14.2292 3.39583 14.0625 3.5625C13.9097 3.71528 13.7153 3.79167 13.4792 3.79167C13.2431 3.79167 13.0486 3.71528 12.8958 3.5625L12.1458 2.83333C12.1181 4.81944 11.8125 6.23264 11.2292 7.07292C10.6458 7.91319 10.0625 8.59722 9.47917 9.125C9.03472 9.52778 8.67361 9.92014 8.39583 10.3021C8.11806 10.684 7.97917 11.2986 7.97917 12.1458V15.4792C7.97917 15.7153 7.8993 15.9132 7.73958 16.0729C7.57986 16.2326 7.38194 16.3125 7.14583 16.3125C6.90972 16.3125 6.71181 16.2326 6.55208 16.0729C6.39236 15.9132 6.3125 15.7153 6.3125 15.4792ZM2.3125 4.79167C2.25694 4.51389 2.21875 4.20833 2.19792 3.875C2.17708 3.54167 2.15972 3.19444 2.14583 2.83333L1.39583 3.58333C1.24306 3.73611 1.05208 3.8125 0.822917 3.8125C0.59375 3.8125 0.395833 3.72917 0.229167 3.5625C0.0763889 3.40972 0 3.21528 0 2.97917C0 2.74306 0.0763889 2.54861 0.229167 2.39583L2.39583 0.229167C2.47917 0.145833 2.56944 0.0868056 2.66667 0.0520833C2.76389 0.0173611 2.86806 0 2.97917 0C3.09028 0 3.19444 0.0173611 3.29167 0.0520833C3.38889 0.0868056 3.47917 0.145833 3.5625 0.229167L5.72917 2.39583C5.89583 2.5625 5.97569 2.75694 5.96875 2.97917C5.96181 3.20139 5.875 3.39583 5.70833 3.5625C5.54167 3.71528 5.34722 3.79167 5.125 3.79167C4.90278 3.79167 4.70833 3.71528 4.54167 3.5625L3.8125 2.85417C3.8125 3.14583 3.82639 3.42014 3.85417 3.67708C3.88194 3.93403 3.90972 4.17361 3.9375 4.39583L2.3125 4.79167ZM4.10417 8.45833C3.82639 8.16667 3.55903 7.82639 3.30208 7.4375C3.04514 7.04861 2.81944 6.56944 2.625 6L4.22917 5.60417C4.36806 5.97917 4.52778 6.29861 4.70833 6.5625C4.88889 6.82639 5.08333 7.0625 5.29167 7.27083L4.10417 8.45833Z" fill=${color}>
          </svg>
          </span>`;
          break;
        case 108:
          icon = `<span style="background: #fff; color: #fff;border: 3px solid ${color}; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-weight: bold;">
          <svg width="16" height="15" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14.4167 15.5833L5.29167 6.47917C5.26389 6.61806 5.23958 6.75694 5.21875 6.89583C5.19792 7.03472 5.1875 7.18056 5.1875 7.33333C5.1875 7.65278 5.22917 7.95486 5.3125 8.23958C5.39583 8.52431 5.51389 8.79167 5.66667 9.04167C5.79167 9.23611 5.8507 9.45139 5.84375 9.6875C5.83681 9.92361 5.75 10.125 5.58333 10.2917C5.41667 10.4583 5.21528 10.5382 4.97917 10.5312C4.74306 10.5243 4.5625 10.4236 4.4375 10.2292C4.14583 9.82639 3.92014 9.375 3.76042 8.875C3.60069 8.375 3.52083 7.86111 3.52083 7.33333C3.52083 6.94444 3.5625 6.56944 3.64583 6.20833C3.72917 5.84722 3.84722 5.50694 4 5.1875L2.77083 3.95833C2.47917 4.45833 2.25347 4.98958 2.09375 5.55208C1.93403 6.11458 1.85417 6.70833 1.85417 7.33333C1.85417 8.11111 1.97222 8.84375 2.20833 9.53125C2.44444 10.2187 2.78472 10.8403 3.22917 11.3958C3.38194 11.5903 3.45833 11.8021 3.45833 12.0312C3.45833 12.2604 3.375 12.4583 3.20833 12.625C3.04167 12.7917 2.84028 12.8715 2.60417 12.8646C2.36806 12.8576 2.17361 12.7569 2.02083 12.5625C1.4375 11.8403 0.986111 11.0382 0.666667 10.1562C0.347222 9.27431 0.1875 8.33333 0.1875 7.33333C0.1875 6.47222 0.309028 5.65972 0.552083 4.89583C0.795139 4.13194 1.13194 3.41667 1.5625 2.75L0.25 1.4375C0.0833333 1.27083 0 1.07292 0 0.84375C0 0.614583 0.0833333 0.416667 0.25 0.25C0.416667 0.0833333 0.614583 0 0.84375 0C1.07292 0 1.27083 0.0833333 1.4375 0.25L15.6042 14.4167C15.7708 14.5833 15.8542 14.7778 15.8542 15C15.8542 15.2222 15.7708 15.4167 15.6042 15.5833C15.4375 15.75 15.2396 15.8333 15.0104 15.8333C14.7813 15.8333 14.5833 15.75 14.4167 15.5833ZM14.9792 11.125C14.7847 11.0139 14.6563 10.8472 14.5938 10.625C14.5313 10.4028 14.5486 10.1875 14.6458 9.97917C14.8264 9.57639 14.9618 9.15278 15.0521 8.70833C15.1424 8.26389 15.1875 7.80555 15.1875 7.33333C15.1875 6.55556 15.0694 5.82292 14.8333 5.13542C14.5972 4.44792 14.2569 3.82639 13.8125 3.27083C13.6597 3.07639 13.5799 2.86458 13.5729 2.63542C13.566 2.40625 13.6458 2.20833 13.8125 2.04167C13.9792 1.875 14.184 1.79514 14.4271 1.80208C14.6701 1.80903 14.8681 1.90972 15.0208 2.10417C15.6042 2.8125 16.0556 3.61111 16.375 4.5C16.6944 5.38889 16.8542 6.33333 16.8542 7.33333C16.8542 7.95833 16.7882 8.56597 16.6563 9.15625C16.5243 9.74653 16.3333 10.3056 16.0833 10.8333C15.9861 11.0278 15.8264 11.1528 15.6042 11.2083C15.3819 11.2639 15.1736 11.2361 14.9792 11.125ZM12.375 9.1875C12.1389 9.13194 11.9618 9.01042 11.8438 8.82292C11.7257 8.63542 11.6944 8.42361 11.75 8.1875C11.7778 8.04861 11.8021 7.90972 11.8229 7.77083C11.8438 7.63194 11.8542 7.48611 11.8542 7.33333C11.8542 7.01389 11.8125 6.71181 11.7292 6.42708C11.6458 6.14236 11.5278 5.875 11.375 5.625C11.25 5.43056 11.1944 5.21528 11.2083 4.97917C11.2222 4.74306 11.3125 4.54167 11.4792 4.375C11.6458 4.20833 11.8403 4.12847 12.0625 4.13542C12.2847 4.14236 12.4653 4.24306 12.6042 4.4375C12.8958 4.84028 13.1215 5.28819 13.2813 5.78125C13.441 6.27431 13.5208 6.79167 13.5208 7.33333C13.5208 7.54167 13.5104 7.75 13.4896 7.95833C13.4688 8.16667 13.4306 8.36806 13.375 8.5625C13.3194 8.78472 13.1979 8.95833 13.0104 9.08333C12.8229 9.20833 12.6111 9.24306 12.375 9.1875Z" fill=${color}>
          </svg>
          </span>`;
          break;
        case 109:
          icon = `<span style="background: #fff; color: #fff;border: 3px solid ${color}; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-weight: bold;">
          <svg width="16" height="16" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.33333 12.5C9.48611 12.5 10.4687 12.0937 11.2812 11.2812C12.0937 10.4687 12.5 9.48611 12.5 8.33333C12.5 7.18056 12.0937 6.19792 11.2812 5.38542C10.4687 4.57292 9.48611 4.16667 8.33333 4.16667C7.18056 4.16667 6.19792 4.57292 5.38542 5.38542C4.57292 6.19792 4.16667 7.18056 4.16667 8.33333C4.16667 9.48611 4.57292 10.4687 5.38542 11.2812C6.19792 12.0937 7.18056 12.5 8.33333 12.5ZM8.33333 16.6667C7.18056 16.6667 6.09722 16.4479 5.08333 16.0104C4.06944 15.5729 3.1875 14.9792 2.4375 14.2292C1.6875 13.4792 1.09375 12.5972 0.65625 11.5833C0.21875 10.5694 0 9.48611 0 8.33333C0 7.18056 0.21875 6.09722 0.65625 5.08333C1.09375 4.06944 1.6875 3.1875 2.4375 2.4375C3.1875 1.6875 4.06944 1.09375 5.08333 0.65625C6.09722 0.21875 7.18056 0 8.33333 0C9.48611 0 10.5694 0.21875 11.5833 0.65625C12.5972 1.09375 13.4792 1.6875 14.2292 2.4375C14.9792 3.1875 15.5729 4.06944 16.0104 5.08333C16.4479 6.09722 16.6667 7.18056 16.6667 8.33333C16.6667 9.48611 16.4479 10.5694 16.0104 11.5833C15.5729 12.5972 14.9792 13.4792 14.2292 14.2292C13.4792 14.9792 12.5972 15.5729 11.5833 16.0104C10.5694 16.4479 9.48611 16.6667 8.33333 16.6667ZM8.33333 15C10.1944 15 11.7708 14.3542 13.0625 13.0625C14.3542 11.7708 15 10.1944 15 8.33333C15 6.47222 14.3542 4.89583 13.0625 3.60417C11.7708 2.3125 10.1944 1.66667 8.33333 1.66667C6.47222 1.66667 4.89583 2.3125 3.60417 3.60417C2.3125 4.89583 1.66667 6.47222 1.66667 8.33333C1.66667 10.1944 2.3125 11.7708 3.60417 13.0625C4.89583 14.3542 6.47222 15 8.33333 15Z" fill=${color}>
          </svg>
          </span>`;
          break;
      }
      return icon;
    },
    async getSvgString(path) {
      const response = await fetch(path);
      return await response.text();
    },
    getAllowedAutoPage(){
      return this.allowAutoPageChange;
    },
    /**
     * Asocia un InfoWindow y evento click al marcador avanzado
     */
    async setInfoContent(index, marker, markerType, colorIcon, lineHaulModal) {
      // Genera el contenido HTML según el tipo de marcador
      let content = '';
      let title = '';
      if (lineHaulModal && (markerType === 'Trip' || markerType === 'Depot' || markerType === 'DepotLH')) {
        [title, content] = this.getSpotInfoWindowContentLH(marker, markerType, marker.trip.state);
      } else if (markerType === 'Trip' || markerType === 'Depot' || markerType === 'DepotLH') {
        content = this.getSpotInfoWindowContent(marker, index);
      } else if (markerType === 'Vehicle') {
        content = this.getVehicleInfoWindow(marker, colorIcon);
      } else if (markerType === 'Event') {
        [title, content] = this.getEventInfoWindowContentSimple(marker, colorIcon);
      } else {
        content = '<div>Marcador</div>';
      }
      // Crea el InfoWindow si no existe
      if (!marker._infoWindow) {
        marker._infoWindow = new this.gapi.maps.InfoWindow({
          content: content,
        });
      } else {
        marker._infoWindow.setContent(content);
      }
      // Remueve listeners previos para evitar duplicados
      if (marker._infoWindowListener) {
        this.gapi.maps.event.removeListener(marker._infoWindowListener);
      }
      // Asocia el click para abrir el InfoWindow
      marker._infoWindowListener = marker.addListener('gmp-click', () => {
        // Cierra el anterior si existe
        if (this.currentInfoWindow) {
          this.currentInfoWindow.close();
        }
        if (this.zoneInfoWindow) {
          this.zoneInfoWindow.close();
        }
        marker._infoWindow.open(this.map, marker);
        this.currentInfoWindow = marker._infoWindow;
        this.currentInfoWindow.eventId = marker?.event?.eventId;
        this.allowAutoPageChange = true;
        setTimeout(() => {
          this.allowAutoPageChange = false;
        }, 1000); 
      });
      if (lineHaulModal) {
        // Listener para aplicar estilos personalizados solo a esta instancia
        this.gapi.maps.event.addListener(marker._infoWindow, 'domready', () => {
          // Fondo lila
          const iwc = document.querySelector('.gm-style .gm-style-iw-c');
          if (iwc) {
            if (markerType == 'Event') {
              iwc.style.backgroundColor = '#FECDCA';
            } else {
              iwc.style.backgroundColor = '#E0D4FD';
            }
            iwc.style.borderRadius = '15px';
            iwc.style.padding = '0px';
          }
          const iwca = document.querySelector('.gm-style-iw-chr');
          if (iwca) {
            const customDiv = document.createElement('div');
            customDiv.innerHTML = title;
            iwca.insertBefore(customDiv, iwca.firstChild);
          }
          const closeButton = document.querySelector('.gm-ui-hover-effect');
          if (closeButton) {
            closeButton.style.display = 'flex';
            closeButton.style.alignItems = 'center';
            closeButton.style.marginTop = '2px';
          }
          // Overflow none
          const iwd = document.querySelector('.gm-style .gm-style-iw-d');
          if (iwd) {
            iwd.style.overflow = 'hidden';
          }
        });
      }
    },
    getEventIdSelected() {
      return this.currentInfoWindow?.eventId || null;
    },
    buildPin({ color, text, icon }) {
      let body = {
        background: color,
        borderColor: 'transparent',
        scale: 1.1,
      };
      if (text) {
        body.glyphText = String(text);
        body.glyphColor = '#fff';
      } else if (icon) {
        body.glyphSrc = icon;
      } else {
        body.glyphColor = '#fff';
      }
      return new this.gapi.maps.marker.PinElement(body);
    },
    markerColor(activity) {
      let colorIcon = null;
      if (
        activity.state === 'ATDESTINATION' ||
        activity.state === 'ENDED' ||
        activity.state === 'DONE' ||
        activity.state === 'ENDOPERATIONDONE'
      ) {
        colorIcon = this.colorIconLastmileV2.done;
      } else if (
        activity.state === 'REJECTED' ||
        activity.state === 'NOTENDED' ||
        activity.state === 'ENDOPERATIONREJECTED'
      ) {
        colorIcon = this.colorIconLastmileV2.rejected;
      } else if (
        activity.state === 'INTRANSIT' ||
        activity.state === 'PARTIALLYDONE' ||
        activity.state === 'ENDOPERATIONPARTIALLYDONE'
      ) {
        colorIcon = this.colorIconLastmileV2.partial;
      } else if (activity.state === 'ACTIVE') {
        colorIcon = this.colorIconLastmileV2.active;
      } else if (activity.state === 'UNACTIVE') {
        colorIcon = this.colorIconLastmileV2.unactive;
      } else {
        colorIcon = this.colorIconLastmileV2.pending;
      }
      return colorIcon;
    },
    //Entrega los puntos de la ruta
    getDirections() {
      let points = [];
      this.drawnPolylines.forEach((polyline) => {
        const pathArray = polyline.getPath();
        for (let i = 0; i < pathArray.getLength(); i++) {
          const latLng = pathArray.getAt(i);
          // Evita duplicados consecutivos
          if (
            points.length === 0 ||
            points[points.length - 1].lat !== latLng.lat() ||
            points[points.length - 1].lon !== latLng.lng()
          ) {
            points.push({
              lat: latLng.lat(),
              lon: latLng.lng(),
            });
          }
        }
      });
      return points;
    },
    //Entrega los puntos claves/Waypoints de la ruta
    getWaypoints() {
      return this.markers[0].waypoints;
    },
    getSpotInfoWindowContentLH(marker, markerType, state) {
      const trip = marker.trip;
      const spotTitle = marker.index === 0 ? marker.trip.origin : marker.trip.destination;
      let icon = null;
      if (markerType === 'Depot') {
        icon = `<span style="background: #7A46FB; color: #fff;border: 3px solid #FFF; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-weight: bold;">
            <svg width="10" height="11" viewBox="0 0 5 7" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0 5.34375V2.19375C0 2.08844 0.0234375 1.98869 0.0703125 1.8945C0.117188 1.80025 0.184375 1.71875 0.271875 1.65L2.29688 0.13125C2.42188 0.04375 2.55625 0 2.7 0C2.84375 0 2.97813 0.04375 3.10313 0.13125L5.12813 1.65C5.21563 1.71875 5.28281 1.80025 5.32969 1.8945C5.37656 1.98869 5.4 2.08844 5.4 2.19375V5.34375C5.4 5.56031 5.32291 5.74569 5.16872 5.89987C5.01447 6.05412 4.82906 6.13125 4.6125 6.13125H3.7125C3.61688 6.13125 3.53672 6.09891 3.47203 6.03422C3.40734 5.96953 3.375 5.88937 3.375 5.79375V3.99375C3.375 3.89812 3.34275 3.81797 3.27825 3.75328C3.21369 3.68859 3.13372 3.65625 3.03834 3.65625H2.36494C2.26956 3.65625 2.18906 3.68859 2.12344 3.75328C2.05781 3.81797 2.025 3.89812 2.025 3.99375V5.79375C2.025 5.88937 1.99266 5.96953 1.92797 6.03422C1.86328 6.09891 1.78313 6.13125 1.6875 6.13125H0.7875C0.570938 6.13125 0.385562 6.05412 0.231375 5.89987C0.0771249 5.74569 0 5.56031 0 5.34375Z" fill="white"/>
            </svg>
          </span>`;
      } else {
        icon = `<span style="background: #7A46FB; color: #fff;border: 3px solid #FFF; border-radius: 50%; width: 24px; height: 24px; display: flex; align-items: center; justify-content: center; font-weight: bold;">${marker.index}</span>`;
      }
      let header = `<div style="background: none; margin-left:10px; margin-top: 5px; margin-bottom: 5px; ">
            <div style="display: flex; align-items: center; gap: 8px;">
              ${icon}
              <span style="font-weight: bold;">${spotTitle.name}</span>
            </div>
            </div>`;
      let body = '<div></div>';
      let atDestinationSchedule = null;
      if (marker.index != 0) {
        if (trip.departureDestination?.delayed) {
          atDestinationSchedule = `${this.t('routeDetailModal.routeDetailModal.endWithDelay')}  
            <span style="font-size:10px; width: 50;height: 12;border-radius: 30px;gap: 5px;opacity: 1;padding: 2px 9px;background: var(--Alerta---7, #fef0c7);"> 
            ${trip.departureDestination.delayed} h </span>`;
        } else {
          atDestinationSchedule = this.t('routeDetailModal.routeDetailModal.endWithoutDelay');
        }
        let durationAtDestination = null;
        if (trip.durationDates?.delayed) {
          durationAtDestination = `${this.t('routeDetailModal.routeDetailModal.permanenceWithDelay')} 
            <span style="font-size:10px; width: 50;height: 12;border-radius: 30px;gap: 5px;opacity: 1;padding: 2px 9px;background: var(--Alerta---7, #fef0c7);"> 
            ${trip.durationDates.delayed} h </span>`;
        } else {
          durationAtDestination = this.t('routeDetailModal.routeDetailModal.permanenceWithoutDelay');
        }
        if (state === 'ATDESTINATION') {
          body += `
        <div style="background: #ffff; border-radius: 15px; padding: 8px 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
          <div>
              <div style="display: flex; align-items: center; gap: 6px;">
                <span>
                  <svg width="10" height="11" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.20833 0.916667C3.07847 0.916667 2.96962 0.872743 2.88177 0.784896C2.79392 0.697049 2.75 0.588194 2.75 0.458333C2.75 0.328472 2.79392 0.219618 2.88177 0.131771C2.96962 0.0439236 3.07847 0 3.20833 0H5.04167C5.17153 0 5.28038 0.0439236 5.36823 0.131771C5.45608 0.219618 5.5 0.328472 5.5 0.458333C5.5 0.588194 5.45608 0.697049 5.36823 0.784896C5.28038 0.872743 5.17153 0.916667 5.04167 0.916667H3.20833ZM4.125 9.625C3.55972 9.625 3.02691 9.51615 2.52656 9.29844C2.02622 9.08073 1.58889 8.78472 1.21458 8.41042C0.840278 8.03611 0.544271 7.59878 0.326563 7.09844C0.108854 6.59809 0 6.06528 0 5.5C0 4.93472 0.108854 4.40191 0.326563 3.90156C0.544271 3.40122 0.840278 2.96389 1.21458 2.58958C1.58889 2.21528 2.02622 1.91927 2.52656 1.70156C3.02691 1.48385 3.55972 1.375 4.125 1.375C4.59861 1.375 5.05313 1.45139 5.48854 1.60417C5.92396 1.75694 6.33264 1.97847 6.71458 2.26875L7.03542 1.94792C7.11944 1.86389 7.22639 1.82188 7.35625 1.82188C7.48611 1.82188 7.59306 1.86389 7.67708 1.94792C7.76111 2.03194 7.80312 2.13889 7.80312 2.26875C7.80312 2.39861 7.76111 2.50556 7.67708 2.58958L7.35625 2.91042C7.64653 3.29236 7.86806 3.70104 8.02083 4.13646C8.17361 4.57188 8.25 5.02639 8.25 5.5C8.25 6.06528 8.14115 6.59809 7.92344 7.09844C7.70573 7.59878 7.40972 8.03611 7.03542 8.41042C6.66111 8.78472 6.22378 9.08073 5.72344 9.29844C5.22309 9.51615 4.69028 9.625 4.125 9.625ZM4.125 8.70833C5.01111 8.70833 5.76736 8.39514 6.39375 7.76875C7.02014 7.14236 7.33333 6.38611 7.33333 5.5C7.33333 4.61389 7.02014 3.85764 6.39375 3.23125C5.76736 2.60486 5.01111 2.29167 4.125 2.29167C3.23889 2.29167 2.48264 2.60486 1.85625 3.23125C1.22986 3.85764 0.916667 4.61389 0.916667 5.5C0.916667 6.38611 1.22986 7.14236 1.85625 7.76875C2.48264 8.39514 3.23889 8.70833 4.125 8.70833Z" fill="#6E6E6E"/>
                      <path d="M5.38549 7.17996H2.86466C2.74562 7.17996 2.64584 7.1397 2.56531 7.05917C2.48478 6.97864 2.44452 6.87886 2.44452 6.75982V4.23899C2.44452 4.11995 2.48478 4.02016 2.56531 3.93964C2.64584 3.85911 2.74562 3.81885 2.86466 3.81885H5.38549C5.50453 3.81885 5.60431 3.85911 5.68484 3.93964C5.76537 4.02016 5.80563 4.11995 5.80563 4.23899V6.75982C5.80563 6.87886 5.76537 6.97864 5.68484 7.05917C5.60431 7.1397 5.50453 7.17996 5.38549 7.17996Z" fill="#6E6E6E"/>
                  </svg>
                </span>
                <span style="font-size:14px">${atDestinationSchedule}</span>
              </div>
            </div>
          </div>`;
        }
        if (state === 'ENDED') {
          body += `
        <div style="background: #ffff; border-radius: 15px; padding: 8px 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
          <div style="margin-top: 8px;">
                <div style="display: flex; align-items: center; gap: 6px;">
                  <span>
                  <svg width="10" height="11" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M3.20833 0.916667C3.07847 0.916667 2.96962 0.872743 2.88177 0.784896C2.79392 0.697049 2.75 0.588194 2.75 0.458333C2.75 0.328472 2.79392 0.219618 2.88177 0.131771C2.96962 0.0439236 3.07847 0 3.20833 0H5.04167C5.17153 0 5.28038 0.0439236 5.36823 0.131771C5.45608 0.219618 5.5 0.328472 5.5 0.458333C5.5 0.588194 5.45608 0.697049 5.36823 0.784896C5.28038 0.872743 5.17153 0.916667 5.04167 0.916667H3.20833ZM4.125 9.625C3.55972 9.625 3.02691 9.51615 2.52656 9.29844C2.02622 9.08073 1.58889 8.78472 1.21458 8.41042C0.840278 8.03611 0.544271 7.59878 0.326563 7.09844C0.108854 6.59809 0 6.06528 0 5.5C0 4.93472 0.108854 4.40191 0.326563 3.90156C0.544271 3.40122 0.840278 2.96389 1.21458 2.58958C1.58889 2.21528 2.02622 1.91927 2.52656 1.70156C3.02691 1.48385 3.55972 1.375 4.125 1.375C4.59861 1.375 5.05313 1.45139 5.48854 1.60417C5.92396 1.75694 6.33264 1.97847 6.71458 2.26875L7.03542 1.94792C7.11944 1.86389 7.22639 1.82188 7.35625 1.82188C7.48611 1.82188 7.59306 1.86389 7.67708 1.94792C7.76111 2.03194 7.80312 2.13889 7.80312 2.26875C7.80312 2.39861 7.76111 2.50556 7.67708 2.58958L7.35625 2.91042C7.64653 3.29236 7.86806 3.70104 8.02083 4.13646C8.17361 4.57188 8.25 5.02639 8.25 5.5C8.25 6.06528 8.14115 6.59809 7.92344 7.09844C7.70573 7.59878 7.40972 8.03611 7.03542 8.41042C6.66111 8.78472 6.22378 9.08073 5.72344 9.29844C5.22309 9.51615 4.69028 9.625 4.125 9.625ZM4.125 8.70833C5.01111 8.70833 5.76736 8.39514 6.39375 7.76875C7.02014 7.14236 7.33333 6.38611 7.33333 5.5C7.33333 4.61389 7.02014 3.85764 6.39375 3.23125C5.76736 2.60486 5.01111 2.29167 4.125 2.29167C3.23889 2.29167 2.48264 2.60486 1.85625 3.23125C1.22986 3.85764 0.916667 4.61389 0.916667 5.5C0.916667 6.38611 1.22986 7.14236 1.85625 7.76875C2.48264 8.39514 3.23889 8.70833 4.125 8.70833Z" fill="#6E6E6E"/>
                      <path d="M5.38549 7.17996H2.86466C2.74562 7.17996 2.64584 7.1397 2.56531 7.05917C2.48478 6.97864 2.44452 6.87886 2.44452 6.75982V4.23899C2.44452 4.11995 2.48478 4.02016 2.56531 3.93964C2.64584 3.85911 2.74562 3.81885 2.86466 3.81885H5.38549C5.50453 3.81885 5.60431 3.85911 5.68484 3.93964C5.76537 4.02016 5.80563 4.11995 5.80563 4.23899V6.75982C5.80563 6.87886 5.76537 6.97864 5.68484 7.05917C5.60431 7.1397 5.50453 7.17996 5.38549 7.17996Z" fill="#6E6E6E"/>
                  </svg>
                  </span>
                  <span style="font-size:14px">${atDestinationSchedule}</span>
                </div>
                <div style="display: flex; align-items: center; gap: 6px;">
                  <span><svg width="10" height="11" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.20833 7.33333C3.33819 7.33333 3.44705 7.28941 3.5349 7.20156C3.62274 7.11372 3.66667 7.00486 3.66667 6.875V4.125C3.66667 3.99514 3.62274 3.88628 3.5349 3.79844C3.44705 3.71059 3.33819 3.66667 3.20833 3.66667C3.07847 3.66667 2.96962 3.71059 2.88177 3.79844C2.79392 3.88628 2.75 3.99514 2.75 4.125V6.875C2.75 7.00486 2.79392 7.11372 2.88177 7.20156C2.96962 7.28941 3.07847 7.33333 3.20833 7.33333ZM5.04167 7.33333C5.17153 7.33333 5.28038 7.28941 5.36823 7.20156C5.45608 7.11372 5.5 7.00486 5.5 6.875V4.125C5.5 3.99514 5.45608 3.88628 5.36823 3.79844C5.28038 3.71059 5.17153 3.66667 5.04167 3.66667C4.91181 3.66667 4.80295 3.71059 4.7151 3.79844C4.62726 3.88628 4.58333 3.99514 4.58333 4.125V6.875C4.58333 7.00486 4.62726 7.11372 4.7151 7.20156C4.80295 7.28941 4.91181 7.33333 5.04167 7.33333ZM3.20833 0.916667C3.07847 0.916667 2.96962 0.872743 2.88177 0.784896C2.79392 0.697049 2.75 0.588194 2.75 0.458333C2.75 0.328472 2.79392 0.219618 2.88177 0.131771C2.96962 0.0439236 3.07847 0 3.20833 0H5.04167C5.17153 0 5.28038 0.0439236 5.36823 0.131771C5.45608 0.219618 5.5 0.328472 5.5 0.458333C5.5 0.588194 5.45608 0.697049 5.36823 0.784896C5.28038 0.872743 5.17153 0.916667 5.04167 0.916667H3.20833ZM4.125 9.625C3.55972 9.625 3.02691 9.51615 2.52656 9.29844C2.02622 9.08073 1.58889 8.78472 1.21458 8.41042C0.840278 8.03611 0.544271 7.59878 0.326562 7.09844C0.108854 6.59809 0 6.06528 0 5.5C0 4.93472 0.108854 4.40191 0.326562 3.90156C0.544271 3.40122 0.840278 2.96389 1.21458 2.58958C1.58889 2.21528 2.02622 1.91927 2.52656 1.70156C3.02691 1.48385 3.55972 1.375 4.125 1.375C4.59861 1.375 5.05312 1.45139 5.48854 1.60417C5.92396 1.75694 6.33264 1.97847 6.71458 2.26875L7.03542 1.94792C7.11944 1.86389 7.22639 1.82188 7.35625 1.82188C7.48611 1.82188 7.59306 1.86389 7.67708 1.94792C7.76111 2.03194 7.80313 2.13889 7.80313 2.26875C7.80313 2.39861 7.76111 2.50556 7.67708 2.58958L7.35625 2.91042C7.64653 3.29236 7.86806 3.70104 8.02083 4.13646C8.17361 4.57188 8.25 5.02639 8.25 5.5C8.25 6.06528 8.14115 6.59809 7.92344 7.09844C7.70573 7.59878 7.40972 8.03611 7.03542 8.41042C6.66111 8.78472 6.22378 9.08073 5.72344 9.29844C5.22309 9.51615 4.69028 9.625 4.125 9.625ZM4.125 8.70833C5.01111 8.70833 5.76736 8.39514 6.39375 7.76875C7.02014 7.14236 7.33333 6.38611 7.33333 5.5C7.33333 4.61389 7.02014 3.85764 6.39375 3.23125C5.76736 2.60486 5.01111 2.29167 4.125 2.29167C3.23889 2.29167 2.48264 2.60486 1.85625 3.23125C1.22986 3.85764 0.916667 4.61389 0.916667 5.5C0.916667 6.38611 1.22986 7.14236 1.85625 7.76875C2.48264 8.39514 3.23889 8.70833 4.125 8.70833Z" fill="#6E6E6E"/>
                    </svg>
                  </span>
                  <span style="font-size:14px">${durationAtDestination}</span>
                </div>
              </div>
            </div>`;
        }
      } else {
        if (state != 'NOTSTARTED') {
          let startDestination = null;
          if (trip.departureOrigin?.delayed) {
            startDestination = `${this.t('routeDetailModal.routeDetailModal.startWithDelay')}  
            <span style="font-size:10px; width: 50;height: 12;border-radius: 30px;gap: 5px;opacity: 1;padding: 2px 9px;background: var(--Alerta---7, #fef0c7);"> 
            ${trip.departureOrigin.delayed} h </span>`;
          } else {
            startDestination = this.t('routeDetailModal.routeDetailModal.startWithoutDelay');
          }
          body += `
        <div style="background: #ffff; border-radius: 12px; padding: 8px 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
          <div style="margin-top: 8px;">
              <div style="display: flex; align-items: center; gap: 6px;">
                <span>
                  <svg width="10" height="11" viewBox="0 0 9 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3.56354 7.09271L5.67188 5.69479C5.74062 5.64896 5.775 5.58403 5.775 5.5C5.775 5.41597 5.74062 5.35104 5.67188 5.30521L3.56354 3.90729C3.48715 3.85382 3.40885 3.84809 3.32865 3.8901C3.24844 3.93212 3.20833 3.99896 3.20833 4.09063V6.90938C3.20833 7.00104 3.24844 7.06788 3.32865 7.1099C3.40885 7.15191 3.48715 7.14618 3.56354 7.09271ZM3.20833 0.916667C3.07847 0.916667 2.96962 0.872743 2.88177 0.784896C2.79392 0.697049 2.75 0.588194 2.75 0.458333C2.75 0.328472 2.79392 0.219618 2.88177 0.131771C2.96962 0.0439236 3.07847 0 3.20833 0H5.04167C5.17153 0 5.28038 0.0439236 5.36823 0.131771C5.45608 0.219618 5.5 0.328472 5.5 0.458333C5.5 0.588194 5.45608 0.697049 5.36823 0.784896C5.28038 0.872743 5.17153 0.916667 5.04167 0.916667H3.20833ZM4.125 9.625C3.55972 9.625 3.02691 9.51615 2.52656 9.29844C2.02622 9.08073 1.58889 8.78472 1.21458 8.41042C0.840278 8.03611 0.544271 7.59878 0.326562 7.09844C0.108854 6.59809 0 6.06528 0 5.5C0 4.93472 0.108854 4.40191 0.326562 3.90156C0.544271 3.40122 0.840278 2.96389 1.21458 2.58958C1.58889 2.21528 2.02622 1.91927 2.52656 1.70156C3.02691 1.48385 3.55972 1.375 4.125 1.375C4.59861 1.375 5.05312 1.45139 5.48854 1.60417C5.92396 1.75694 6.33264 1.97847 6.71458 2.26875L7.03542 1.94792C7.11944 1.86389 7.22639 1.82188 7.35625 1.82188C7.48611 1.82188 7.59306 1.86389 7.67708 1.94792C7.76111 2.03194 7.80313 2.13889 7.80313 2.26875C7.80313 2.39861 7.76111 2.50556 7.67708 2.58958L7.35625 2.91042C7.64653 3.29236 7.86806 3.70104 8.02083 4.13646C8.17361 4.57188 8.25 5.02639 8.25 5.5C8.25 6.06528 8.14115 6.59809 7.92344 7.09844C7.70573 7.59878 7.40972 8.03611 7.03542 8.41042C6.66111 8.78472 6.22378 9.08073 5.72344 9.29844C5.22309 9.51615 4.69028 9.625 4.125 9.625ZM4.125 8.70833C5.01111 8.70833 5.76736 8.39514 6.39375 7.76875C7.02014 7.14236 7.33333 6.38611 7.33333 5.5C7.33333 4.61389 7.02014 3.85764 6.39375 3.23125C5.76736 2.60486 5.01111 2.29167 4.125 2.29167C3.23889 2.29167 2.48264 2.60486 1.85625 3.23125C1.22986 3.85764 0.916667 4.61389 0.916667 5.5C0.916667 6.38611 1.22986 7.14236 1.85625 7.76875C2.48264 8.39514 3.23889 8.70833 4.125 8.70833Z" fill="#6E6E6E"/>
                  </svg>
                </span>
                <span style="font-size:14px">${startDestination}</span>
              </div>
            </div>
          </div>`;
        }
      }
      return [header, body];
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que retorna la estructura html de un trip.
     * @param {Trip} marker, es el punto del trip dentro del mapa.
     * @param {Integer} index, es la posicion del punto del trip.
     * @returns {String} structura html de la ventana de info.
     */
    getSpotInfoWindowContent: function (marker, index) {
      const schedArrival =
        this.t('routeDetailModal.routeDetailModal.endTrip') +
        ' ' +
        this.t('routeDetailModal.routeDetailModal.schedTimeReduced');
      const schedArrivalTime = this.t('routeDetailModal.routeDetailModal.time', {
        time:
          index !== 0 && this.trips[index - 1] && this.trips[index - 1].arrivalDestination
            ? this.trips[index - 1].arrivalDestination.sched
            : '--:--',
      });
      const schedArrivalText = `
          <div style="font-weight:500; margin-top: 8px; color: #03475e; fill: #03475e; position: absolute; left: -0.5%;">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 24 24"
              height="18px"
              viewBox="0 0 24 24"
              width="18px"
            >
              <g><rect fill="none" height="24" width="24" /></g>
              <g>
                <g>
                  <rect height="2" width="6" x="9" y="1" />
                  <path
                    d="M19.03,7.39l1.42-1.42c-0.43-0.51-0.9-0.99-1.41-1.41l-1.42,1.42C16.07,4.74,14.12,4,12,4c-4.97,0-9,4.03-9,9 c0,4.97,4.02,9,9,9s9-4.03,9-9C21,10.88,20.26,8.93,19.03,7.39z M13,14h-2V8h2V14z"
                  />
                </g>
              </g>
            </svg>
            ${schedArrival}:
          </div>
          <div style="font-weight:500; margin-top: 8px; color: #03475e; fill: #03475e; position: absolute; right: 0%;">                               
            ${schedArrivalTime}
          </div>
          `;

      const arrivalTimeTemp =
        index !== 0 && this.trips[index - 1] && this.trips[index - 1].arrivalDestination
          ? this.trips[index - 1].arrivalDestination.real
          : '--:--';
      const realArrival =
        this.t('routeDetailModal.routeDetailModal.endTrip') +
        ' ' +
        this.t('routeDetailModal.routeDetailModal.realTime');
      const realArrivalTime = this.t('routeDetailModal.routeDetailModal.time', {
        time: arrivalTimeTemp !== null ? arrivalTimeTemp : '--:--',
      });
      const realArrivalText = `
          <div style="font-weight:500; margin-top: 32px; color: #e69c21; fill: #e69c21; position: absolute; left: -0.5%;">
            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px">
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
              />
              <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
            </svg>
            ${realArrival}:
          </div>
          <div style="font-weight:500; margin-top: 32px; color: #e69c21; fill: #e69c21; position: absolute; right: 0%;">                               
            ${realArrivalTime}
          </div>
          `;
      const schedDeparture =
        this.t('routeDetailModal.routeDetailModal.startTrip') +
        ' ' +
        this.t('routeDetailModal.routeDetailModal.schedTimeReduced');
      const schedDepartureTime = this.t('routeDetailModal.routeDetailModal.time', {
        time: marker.trip.departureOrigin ? marker.trip.departureOrigin.sched : '--:--',
      });
      const schedDepartureText = `
          <div style="font-weight:500; margin-top: 8px; color: #03475e; fill: #03475e; position: absolute; left: -0.5%;">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              enable-background="new 0 0 24 24"
              height="18px"
              viewBox="0 0 24 24"
              width="18px"
            >
              <g><rect fill="none" height="24" width="24" /></g>
              <g>
                <g>
                  <rect height="2" width="6" x="9" y="1" />
                  <path
                    d="M19.03,7.39l1.42-1.42c-0.43-0.51-0.9-0.99-1.41-1.41l-1.42,1.42C16.07,4.74,14.12,4,12,4c-4.97,0-9,4.03-9,9 c0,4.97,4.02,9,9,9s9-4.03,9-9C21,10.88,20.26,8.93,19.03,7.39z M13,14h-2V8h2V14z"
                  />
                </g>
              </g>
            </svg>
            ${schedDeparture}:
          </div>
          <div style="font-weight:500; margin-top: 8px; color: #03475e; fill: #03475e; position: absolute; right: 0%;">                               
            ${schedDepartureTime}
          </div>
          `;
      const spotTitle = marker.index != this.markers.length - 1 ? marker.trip.origin : marker.trip.destination;
      const spotAddress =
        marker.index != this.markers.length - 1
          ? marker.trip.originAddress.street
          : marker.trip.destinationAddress.street;

      const realDeparture =
        this.t('routeDetailModal.routeDetailModal.startTrip') +
        ' ' +
        this.t('routeDetailModal.routeDetailModal.realTime');
      const realDepartureTime = this.t('routeDetailModal.routeDetailModal.time', {
        time:
          marker.trip.departureOrigin && marker.trip.departureOrigin.real !== null
            ? marker.trip.departureOrigin.real
            : '--:--',
      });
      const realDepartureText = `
          <div style="font-weight:500; margin-top: 32px; color: #e69c21; fill: #e69c21; position: absolute; left: -0.5%;">
            <svg xmlns="http://www.w3.org/2000/svg" height="18px" viewBox="0 0 24 24" width="18px">
              <path d="M0 0h24v24H0z" fill="none" />
              <path
                d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
              />
              <path d="M12.5 7H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
            </svg>
            ${realDeparture}:
          </div>
          <div style="font-weight:500; margin-top: 32px; color: #e69c21; fill: #e69c21; position: absolute; right: 0%;">                               
            ${realDepartureTime}
          </div>
          `;
      if (marker.trip.departureOrigin) {
        return `
            <div class="card" style="height:120px; width:180px; minWidth:250px;border:0;">
                    <div class="card-content">
                      <span style="fill: #0096ca;">
                        <svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 0 36 32" width="25px">
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path
                            d="M10.5,26 C17.5,19.3170648 21,14.0809537 21,10.2916667 C21,4.60773612 16.2989899,0 10.5,0 C4.70101013,0 0,4.60773612 0,10.2916667 C0,14.0809537 3.5,19.3170648 10.5,26 Z"
                          />
                        </svg>
                        <span style="font-size: 110%;font-weight: bold;">
                          ${spotTitle}
                        </span>
                      </span>
                      <div class="content" style="color:#6c757d;">
                        <span style="color: #686868;font-weight:500">
                          ${spotAddress}
                        </span>
                        <div style="position: relative; text-align: center;">
                          ${index !== 0 ? schedArrivalText : schedDepartureText}
                        </div>
                        <div style="position: relative; text-align: center;">
                          ${index !== 0 ? realArrivalText : realDepartureText}
                        </div>
                      </div>
                    </div>
                </div>
            </div>`;
      } else {
        return `
            <div class="card" style="height:auto; width:180px; minWidth:250px;border:0;">
                    <div class="card-content">
                      <span style="fill: #0096ca;">
                        <svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 0 36 32" width="25px">
                          <path d="M0 0h24v24H0z" fill="none" />
                          <path
                            d="M10.5,26 C17.5,19.3170648 21,14.0809537 21,10.2916667 C21,4.60773612 16.2989899,0 10.5,0 C4.70101013,0 0,4.60773612 0,10.2916667 C0,14.0809537 3.5,19.3170648 10.5,26 Z"
                          />
                        </svg>
                        <span style="font-size: 110%;font-weight: bold;">
                          ${spotTitle}
                        </span>
                      </span>
                      <div class="content" style="color:#6c757d;">
                        <span style="color: #686868;font-weight:500">
                          ${spotAddress}
                        </span>
                      </div>
                    </div>
                </div>
            </div>`;
      }
    },

    getEventInfoWindowContentSimple: function (marker, color) {
      const event = marker.event;
      const icon = this.chooseIcon(event.eventType, color);
      let header = `<div style="background: none; margin-left:10px; margin-top: 5px; margin-bottom: 5px; ">
        <div style="display: flex; align-items: center; gap: 8px;">
          ${icon}
          <span style="font-weight: bold;">${event.nameEvent}</span>
        </div>
        </div>`;

      let body = '<div></div>';
      const address = event.address;
      const eventDate = moment(event.initEvent).format('DD/MM/YY HH:mm');
      body = `
      <div style="background: #ffff; border-radius: 15px; padding: 8px 12px; box-shadow: 0 2px 8px rgba(0,0,0,0.08);">
          <div style="width: 250px;">
                <div style="display: flex; align-items: center; gap: 6px;">
                  <span style="font-size:14px">${address}</span>
                </div>
                <div style="display: flex; align-items: center; gap: 6px; margin-top: 10px">
                  </span>
                  <span style="font-size:14px">${eventDate} h</span>
                </div>
              </div>
            </div>`;

      return [header, body];
    },
    getVehicleInfoWindow: function (marker, color) {
      //para este caso el typeName es la patente del vehículo
      const spotTitle = marker.trip.typeName;

      return `<div class="card" style="height:auto; width:100%; margin-top: 5px; border:0;">
                    <div class="card-content">
                      <div style="fill: ${color}; min-width: 150px;" >
                        <span style="font-size: 130%;font-weight: bold;">
                          Indicadores del dispositivo
                        </span>
                      </div>
                      <div style="display: flex; margin-top: 10px">
                        <div style="display: flex; justify-content:center; align-items:center;">
                          <svg width="25" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <mask id="mask0_110_3956" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18">
                            <rect x="0.0146484" width="17.8328" height="17.8328" fill="#D9D9D9"/>
                            </mask>
                            <g mask="url(#mask0_110_3956)">
                            <path d="M4.47324 14.1175V14.8606C4.47324 15.0711 4.40203 15.2476 4.25961 15.39C4.1172 15.5324 3.94073 15.6036 3.7302 15.6036H2.98717C2.77665 15.6036 2.60018 15.5324 2.45776 15.39C2.31535 15.2476 2.24414 15.0711 2.24414 14.8606V8.91631L3.80451 4.45812C3.87881 4.23521 4.01194 4.05564 4.20389 3.91942C4.39584 3.7832 4.60946 3.71509 4.84475 3.71509H13.0181C13.2534 3.71509 13.467 3.7832 13.659 3.91942C13.8509 4.05564 13.984 4.23521 14.0583 4.45812L15.6187 8.91631V14.8606C15.6187 15.0711 15.5475 15.2476 15.4051 15.39C15.2627 15.5324 15.0862 15.6036 14.8757 15.6036H14.1326C13.9221 15.6036 13.7457 15.5324 13.6032 15.39C13.4608 15.2476 13.3896 15.0711 13.3896 14.8606V14.1175H4.47324ZM4.32463 7.43025H13.5382L12.758 5.20115H5.10481L4.32463 7.43025ZM5.58778 11.8884C5.89738 11.8884 6.16054 11.7801 6.37725 11.5634C6.59397 11.3466 6.70233 11.0835 6.70233 10.7739C6.70233 10.4643 6.59397 10.2011 6.37725 9.98442C6.16054 9.7677 5.89738 9.65934 5.58778 9.65934C5.27819 9.65934 5.01503 9.7677 4.79831 9.98442C4.58159 10.2011 4.47324 10.4643 4.47324 10.7739C4.47324 11.0835 4.58159 11.3466 4.79831 11.5634C5.01503 11.7801 5.27819 11.8884 5.58778 11.8884ZM12.2751 11.8884C12.5847 11.8884 12.8478 11.7801 13.0645 11.5634C13.2813 11.3466 13.3896 11.0835 13.3896 10.7739C13.3896 10.4643 13.2813 10.2011 13.0645 9.98442C12.8478 9.7677 12.5847 9.65934 12.2751 9.65934C11.9655 9.65934 11.7023 9.7677 11.4856 9.98442C11.2689 10.2011 11.1605 10.4643 11.1605 10.7739C11.1605 11.0835 11.2689 11.3466 11.4856 11.5634C11.7023 11.7801 11.9655 11.8884 12.2751 11.8884ZM3.7302 12.6315H14.1326V8.91631H3.7302V12.6315Z" fill="#6825F3"/>
                    </g>
                  </svg>
                  <span style="font-size: 120%;justify-content:center; align-items:center; margin-left: 5px">
                    ${spotTitle}
                  </span>
                </div>
                <div style="display: flex; justify-content:center; align-items:center; margin-left: 10px">
                  ${this.getBattery(marker)}
                </div>
                <div style="display: flex; justify-content:center; align-items:center; margin-left: 10px">
                  ${this.getSignal(marker)}
                </div>
              </div>
              
              <div style="display: flex; margin-top: 10px">
                <div style="display: flex; justify-content:center; align-items:center;">
                  ${this.getAppVersion(marker)}
                </div>
              </div>
            </div>
          </div>`;
    },
    getAppVersion(marker) {
      if (marker.lifeSignal) {
        return `
              <span style="font-size: 120%;justify-content:center; align-items:center">
                Versión ${marker.lifeSignal.appVersion}
              </span>`;
      } else {
        return `
            <span style="font-size: 120%;justify-content:center; align-items:center">
              Versión 1.0.0
            </span>`;
      }
    },
    getBattery(marker) {
      if (marker.lifeSignal) {
        return `
                  <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_110_3951" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="17">
                    <rect width="16.8035" height="16.8035" fill="#D9D9D9"/>
                    </mask>
                    <g mask="url(#mask0_110_3951)">
                    <path d="M5.60151 15.403C5.40314 15.403 5.23685 15.3359 5.10266 15.2017C4.96846 15.0675 4.90137 14.9013 4.90137 14.7029V3.50058C4.90137 3.30221 4.96846 3.13592 5.10266 3.00173C5.23685 2.86753 5.40314 2.80044 5.60151 2.80044H7.0018V1.40015H9.80238V2.80044H11.2027C11.401 2.80044 11.5673 2.86753 11.7015 3.00173C11.8357 3.13592 11.9028 3.30221 11.9028 3.50058V14.7029C11.9028 14.9013 11.8357 15.0675 11.7015 15.2017C11.5673 15.3359 11.401 15.403 11.2027 15.403H5.60151ZM6.30166 12.6025H10.5025V4.20072H6.30166V12.6025Z" fill="#6825F3"/>
                    </g>
                  </svg>
                  <span style="font-size: 120%;justify-content:center; align-items:center;">
                    ${marker.lifeSignal.battery}%
                  </span>
            `;
      } else {
        return `
            <span style="font-size: 120%;justify-content:center; align-items:center; margin-left: 5px">
              0%
            </span>
            `;
      }
    },
    getSignal(marker) {
      if (marker.lifeSignal) {
        let signalText = '';
        if (marker.lifeSignal.signal > -60) {
          signalText = `
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.15375 15C0.83325 15 0.560833 14.8878 0.3365 14.6635C0.112167 14.4392 0 14.1667 0 13.8462V11.1538C0 10.8333 0.112167 10.5608 0.3365 10.3365C0.560833 10.1122 0.83325 10 1.15375 10C1.47425 10 1.74675 10.1122 1.97125 10.3365C2.19558 10.5608 2.30775 10.8333 2.30775 11.1538V13.8462C2.30775 14.1667 2.19558 14.4392 1.97125 14.6635C1.74675 14.8878 1.47425 15 1.15375 15Z" fill="#6825F3"/>
                <path d="M13.154 15C12.8335 15 12.561 14.8878 12.3365 14.6635C12.1122 14.4392 12 14.1667 12 13.8462V1.15375C12 0.833251 12.1122 0.560834 12.3365 0.336501C12.561 0.112167 12.8335 0 13.154 0C13.4745 0 13.7469 0.112167 13.9712 0.336501C14.1956 0.560834 14.3078 0.833251 14.3078 1.15375V13.8462C14.3078 14.1667 14.1956 14.4392 13.9712 14.6635C13.7469 14.8878 13.4745 15 13.154 15Z" fill="#6825F3"/>
                <path d="M7.15375 15C6.83325 15 6.56083 14.8878 6.3365 14.6635C6.11217 14.4392 6 14.1668 6 13.8463V6.15375C6 5.83325 6.11217 5.56083 6.3365 5.3365C6.56083 5.11217 6.83325 5 7.15375 5C7.47425 5 7.74667 5.11217 7.971 5.3365C8.19533 5.56083 8.3075 5.83325 8.3075 6.15375V13.8463C8.3075 14.1668 8.19533 14.4392 7.971 14.6635C7.74667 14.8878 7.47425 15 7.15375 15Z" fill="#6825F3"/>
              </svg>
              <span style="font-size: 120%;justify-content:center; align-items:center; margin-left: 5px">
                Alta
              </span>
              `;
        } else if (marker.lifeSignal.signal <= -60 && marker.lifeSignal.signal >= -89) {
          signalText = `
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.15375 15C0.83325 15 0.560834 14.8878 0.3365 14.6635C0.112167 14.4392 0 14.1667 0 13.8462V11.1538C0 10.8333 0.112167 10.5608 0.3365 10.3365C0.560834 10.1122 0.83325 10 1.15375 10C1.47425 10 1.74675 10.1122 1.97125 10.3365C2.19558 10.5608 2.30775 10.8333 2.30775 11.1538V13.8462C2.30775 14.1667 2.19558 14.4392 1.97125 14.6635C1.74675 14.8878 1.47425 15 1.15375 15Z" fill="#6825F3"/>
                <path d="M13.154 15C12.8335 15 12.561 14.8878 12.3365 14.6635C12.1122 14.4392 12 14.1667 12 13.8462V1.15375C12 0.833251 12.1122 0.560834 12.3365 0.336501C12.561 0.112167 12.8335 0 13.154 0C13.4745 0 13.7469 0.112167 13.9712 0.336501C14.1956 0.560834 14.3078 0.833251 14.3078 1.15375V13.8462C14.3078 14.1667 14.1956 14.4392 13.9712 14.6635C13.7469 14.8878 13.4745 15 13.154 15Z" fill="#E7E1F5"/>
                <path d="M7.15375 15C6.83325 15 6.56083 14.8878 6.3365 14.6635C6.11217 14.4392 6 14.1668 6 13.8463V6.15375C6 5.83325 6.11217 5.56083 6.3365 5.3365C6.56083 5.11217 6.83325 5 7.15375 5C7.47425 5 7.74667 5.11217 7.971 5.3365C8.19533 5.56083 8.3075 5.83325 8.3075 6.15375V13.8463C8.3075 14.1668 8.19533 14.4392 7.971 14.6635C7.74667 14.8878 7.47425 15 7.15375 15Z" fill="#6825F3"/>
              </svg>
              <span style="font-size: 120%;justify-content:center; align-items:center; margin-left: 5px">
                Media
              </span>
              `;
        } else if (marker.lifeSignal.signal <= -90 && marker.lifeSignal.signal >= -200) {
          signalText = `
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.15375 15C0.83325 15 0.560834 14.8878 0.3365 14.6635C0.112167 14.4392 0 14.1667 0 13.8462V11.1538C0 10.8333 0.112167 10.5608 0.3365 10.3365C0.560834 10.1122 0.83325 10 1.15375 10C1.47425 10 1.74675 10.1122 1.97125 10.3365C2.19558 10.5608 2.30775 10.8333 2.30775 11.1538V13.8462C2.30775 14.1667 2.19558 14.4392 1.97125 14.6635C1.74675 14.8878 1.47425 15 1.15375 15Z" fill="#6825F3"/>
                <path d="M13.154 15C12.8335 15 12.561 14.8878 12.3365 14.6635C12.1122 14.4392 12 14.1667 12 13.8462V1.15375C12 0.833251 12.1122 0.560834 12.3365 0.336501C12.561 0.112167 12.8335 0 13.154 0C13.4745 0 13.7469 0.112167 13.9712 0.336501C14.1956 0.560834 14.3078 0.833251 14.3078 1.15375V13.8462C14.3078 14.1667 14.1956 14.4392 13.9712 14.6635C13.7469 14.8878 13.4745 15 13.154 15Z" fill="#E7E1F5"/>
                <path d="M7.15375 15C6.83325 15 6.56083 14.8878 6.3365 14.6635C6.11217 14.4392 6 14.1668 6 13.8463V6.15375C6 5.83325 6.11217 5.56083 6.3365 5.3365C6.56083 5.11217 6.83325 5 7.15375 5C7.47425 5 7.74667 5.11217 7.971 5.3365C8.19533 5.56083 8.3075 5.83325 8.3075 6.15375V13.8463C8.3075 14.1668 8.19533 14.4392 7.971 14.6635C7.74667 14.8878 7.47425 15 7.15375 15Z" fill="#6825F3"/>
              </svg>
              <span style="font-size: 120%;justify-content:center; align-items:center; margin-left: 5px">
                Baja
              </span>
              `;
        } else {
          signalText = `
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1.15375 15C0.83325 15 0.560834 14.8878 0.3365 14.6635C0.112167 14.4392 0 14.1667 0 13.8462V11.1538C0 10.8333 0.112167 10.5608 0.3365 10.3365C0.560834 10.1122 0.83325 10 1.15375 10C1.47425 10 1.74675 10.1122 1.97125 10.3365C2.19558 10.5608 2.30775 10.8333 2.30775 11.1538V13.8462C2.30775 14.1667 2.19558 14.4392 1.97125 14.6635C1.74675 14.8878 1.47425 15 1.15375 15Z" fill="#E7E1F5"/>
                <path d="M13.154 15C12.8335 15 12.561 14.8878 12.3365 14.6635C12.1122 14.4392 12 14.1667 12 13.8462V1.15375C12 0.833251 12.1122 0.560834 12.3365 0.336501C12.561 0.112167 12.8335 0 13.154 0C13.4745 0 13.7469 0.112167 13.9712 0.336501C14.1956 0.560834 14.3078 0.833251 14.3078 1.15375V13.8462C14.3078 14.1667 14.1956 14.4392 13.9712 14.6635C13.7469 14.8878 13.4745 15 13.154 15Z" fill="#E7E1F5"/>
                <path d="M7.15375 15C6.83325 15 6.56083 14.8878 6.3365 14.6635C6.11217 14.4392 6 14.1668 6 13.8463V6.15375C6 5.83325 6.11217 5.56083 6.3365 5.3365C6.56083 5.11217 6.83325 5 7.15375 5C7.47425 5 7.74667 5.11217 7.971 5.3365C8.19533 5.56083 8.3075 5.83325 8.3075 6.15375V13.8463C8.3075 14.1668 8.19533 14.4392 7.971 14.6635C7.74667 14.8878 7.47425 15 7.15375 15Z" fill="#E7E1F5"/>
              </svg>
              <span style="font-size: 120%;justify-content:center; align-items:center; margin-left: 5px">
                Sin señal
              </span>
              `;
        }
        return signalText;
      } else {
        return `
            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.15375 15C0.83325 15 0.560834 14.8878 0.3365 14.6635C0.112167 14.4392 0 14.1667 0 13.8462V11.1538C0 10.8333 0.112167 10.5608 0.3365 10.3365C0.560834 10.1122 0.83325 10 1.15375 10C1.47425 10 1.74675 10.1122 1.97125 10.3365C2.19558 10.5608 2.30775 10.8333 2.30775 11.1538V13.8462C2.30775 14.1667 2.19558 14.4392 1.97125 14.6635C1.74675 14.8878 1.47425 15 1.15375 15Z" fill="#E7E1F5"/>
              <path d="M13.154 15C12.8335 15 12.561 14.8878 12.3365 14.6635C12.1122 14.4392 12 14.1667 12 13.8462V1.15375C12 0.833251 12.1122 0.560834 12.3365 0.336501C12.561 0.112167 12.8335 0 13.154 0C13.4745 0 13.7469 0.112167 13.9712 0.336501C14.1956 0.560834 14.3078 0.833251 14.3078 1.15375V13.8462C14.3078 14.1667 14.1956 14.4392 13.9712 14.6635C13.7469 14.8878 13.4745 15 13.154 15Z" fill="#E7E1F5"/>
              <path d="M7.15375 15C6.83325 15 6.56083 14.8878 6.3365 14.6635C6.11217 14.4392 6 14.1668 6 13.8463V6.15375C6 5.83325 6.11217 5.56083 6.3365 5.3365C6.56083 5.11217 6.83325 5 7.15375 5C7.47425 5 7.74667 5.11217 7.971 5.3365C8.19533 5.56083 8.3075 5.83325 8.3075 6.15375V13.8463C8.3075 14.1668 8.19533 14.4392 7.971 14.6635C7.74667 14.8878 7.47425 15 7.15375 15Z" fill="#E7E1F5"/>
            </svg>
            <span style="font-size: 120%;justify-content:center; align-items:center; margin-left: 5px">
              Sin señal
            </span>
            `;
      }
    },
    /**
     * Metodo que retorna la estructura html de un trip en una version que solo contiene el tipo y la calle.
     * @param {Trip} marker, es el punto del trip dentro del mapa.
     * @returns {String} estructura html de la ventana de info.
     */
    getSpotInfoWindowContentSimple: function (marker, color) {
      const spotTitle = marker.trip.typeName;
      const spotAddress = marker.trip.formattedStreet;
      if (marker.trip.state != undefined) {
        color = '#804FF8';
        const type = marker.trip.type == 'DELIVERY' ? 'entrega' : 'retiro';
        return marker.trip.state != 'PLANNED'
          ? `<div class="card" style="height:auto; width:100%; minWidth:400px;border:0;">
                            <div class="card-content">
                              <div style="color: ${color}; min-width: 150px;" >
                                <span style="font-size: 110%;font-weight: bold;">
                                  ${spotTitle}
                                </span>
                              </div>
                              <div class="content" style="color:#6c757d;">
                                <span style="color: #686868;font-weight:500">
                                  <span style="font-size: 500;font-weight: bold;">
                                    Coordenadas ${type}: 
                                  </span>
                                  ${marker.trip.coordinates.lat}, ${marker.trip.coordinates.lng}
                                </span>
                              </div>
                              <div class="content" style="color:#6c757d;">
                                <span style="color: #686868;font-weight:500">
                                  <span style="font-size: 500;font-weight: bold;">
                                    Fecha y hora ${type}: 
                                  </span>
                                  ${marker.trip.scheduled}
                                </span>
                              </div>
                            </div>
                        </div>
                    </div>`
          : `<div class="card" style="height:auto; width:95%; minWidth:380px;border:0;">
                          <div class="card-content">
                            <div style="color: ${color}; min-width: 150px;" >
                              <span style="font-size: 110%;font-weight: bold;">
                                ${spotTitle}
                              </span>
                            </div>
                            <div class="content" style="color:#6c757d;">
                              <span style="color: #686868;font-weight:500">
                                ${spotAddress}
                              </span>
                            </div>
                          </div>
                      </div>
                  </div>`;
      }

      return marker.trip.typeActivity == null
        ? `<div class="card" style="height:auto; width:95%; minWidth:380px;border:0;">
                          <div class="card-content">
                            <div style="fill: ${color}; min-width: 150px;" >
                              <svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 0 36 32" width="25px">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path
                                  d="M10.5,26 C17.5,19.3170648 21,14.0809537 21,10.2916667 C21,4.60773612 16.2989899,0 10.5,0 C4.70101013,0 0,4.60773612 0,10.2916667 C0,14.0809537 3.5,19.3170648 10.5,26 Z"
                                />
                              </svg>
                              <span style="font-size: 110%;font-weight: bold;">
                                ${spotTitle}
                              </span>
                            </div>
                            <div class="content" style="color:#6c757d;">
                              <span style="color: #686868;font-weight:500">
                                ${spotAddress}
                              </span>
                            </div>
                          </div>
                      </div>
                  </div>`
        : `<div class="card" style="height:auto; width:95%; minWidth:380px;border:0;">
                          <div class="card-content">
                            <div style="fill: ${color}; min-width: 150px;" >
                              <svg xmlns="http://www.w3.org/2000/svg" height="25px" viewBox="0 0 36 32" width="25px">
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path
                                  d="M10.5,26 C17.5,19.3170648 21,14.0809537 21,10.2916667 C21,4.60773612 16.2989899,0 10.5,0 C4.70101013,0 0,4.60773612 0,10.2916667 C0,14.0809537 3.5,19.3170648 10.5,26 Z"
                                />
                              </svg>
                              <span style="font-size: 110%;font-weight: bold;">
                                ${spotTitle}
                              </span>
                            </div>
                            <div class="content" style="color:#6c757d;">
                              <span style="color: #686868;font-weight:500">
                                ${marker.trip.typeActivity == 'COLLECTION' ? 'Tipo retiro' : 'Tipo entrega'}
                              </span>
                            </div>
                            <div class="content" style="color:#6c757d;">
                              <span style="color: #686868;font-weight:500">
                                ${spotAddress}
                              </span>
                            </div>
                          </div>
                      </div>
                  </div>`;
    },
    /**@author Jorge Pizarro Tapia
     * Metodo que permite interactuar con los .json de las traducciones.
     * @param {String} key, es el elemento del .json a utilizar.
     * @param {String} value, es la variable a insertar (en caso de que el elemento lo solicite).
     * @returns el resultado de la traduccion.
     */
    t(key, value) {
      return i18n.t(key, value);
    },
    cleanCluster() {
      if (this.markerCluster) {
        this.markerCluster.clearMarkers(); // Elimina todos los marcadores del cluster
        this.markerCluster = null; // Elimina la referencia del cluster
      }
    },
    /**
     * Metodo que limpia los marcadores del mapa
     */
    cleanMapMarkers() {
      if (this.googleMarkers.length > 1) {
        this.googleMarkers.forEach((marker) => {
          marker.setMap(null);
        });
      }
      if (this.vehiclePositionMarker) {
        this.vehiclePositionMarker.forEach((marker) => {
          marker.setMap(null);
        });
      }
      if (this.actualPositionVeh) {
        this.actualPositionVeh.setMap(null);
      }
      this.actualPositionVeh = null;
      this.vehiclePositionMarker = [];
      this.googleMarkers = [];
    },
    cleanMarkersFromSpiderfier() {
      if (this.oms) {
        this.oms.clearMarkers();
      }
    },
    //Vacia el mapa
    setMapNull() {
      this.clearZones();
    },
    clearZones() {
      if (this.geoFencePoints.length > 0) {
        this.geoFencePoints.forEach((geoZone) => {
          geoZone.setMap(null);
        });
      }
      this.geoFencePoints = [];
      if (this.zoneInfoWindow) {
        this.zoneInfoWindow.close();
      }
    },
    drawZones(zones) {
      zones.forEach((spotZone) => {
        const points = spotZone.points || spotZone.zone || [];
        if (points.length >= 3) {
          this.makePolygon(points, spotZone);
        } else if (points.length === 1) {
          this.makeCircle(points, spotZone);
        }
      });
    },
    openZoneInfoWindow(position, zoneMeta = {}) {
      if (!this.map || !this.gapi?.maps?.InfoWindow) return;
      if (!this.zoneInfoWindow) {
        this.zoneInfoWindow = new this.gapi.maps.InfoWindow();
      }
      const color = zoneMeta.color || '#6226F7';
      const rawName = zoneMeta.name || this.t('routeDetailModal.legend.zones');
      const name = String(rawName)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
      const title = `
        <div style="background:none;margin-left:10px;margin-top:9px;margin-bottom:5px;">
          <div style="display:flex;align-items:center;gap:8px;">
            <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
              <circle cx="7" cy="7" r="7" fill="${color}"/>
            </svg>
            <span style="font-weight:bold;">${name}</span>
          </div>
        </div>
      `;
      if (this.currentInfoWindow) {
        this.currentInfoWindow.close();
      }
      this.zoneInfoWindow.setContent('<div></div>');
      this.zoneInfoWindow.setPosition(position);
      this.zoneInfoWindow.open(this.map);
      this.gapi.maps.event.addListenerOnce(this.zoneInfoWindow, 'domready', () => {
        const iwc = document.querySelector('.gm-style .gm-style-iw-c');
        if (iwc) {
          iwc.style.padding = '0px';
        }
        const iwca = document.querySelector('.gm-style-iw-chr');
        if (iwca) {
          iwca.querySelector('.zone-title-div')?.remove();
          const customDiv = document.createElement('div');
          customDiv.className = 'zone-title-div';
          customDiv.innerHTML = title;
          iwca.insertBefore(customDiv, iwca.firstChild);
        }
        const closeButton = document.querySelector('.gm-ui-hover-effect');
        if (closeButton) {
          closeButton.style.display = 'flex';
          closeButton.style.alignItems = 'center';
          closeButton.style.marginTop = '2px';
        }
        const iwd = document.querySelector('.gm-style .gm-style-iw-d');
        if (iwd) {
          iwd.style.overflow = 'hidden';
        }
      });
    },
    decodePolyline(encoded) {
      let points = [];
      let index = 0,
        lat = 0,
        lng = 0;

      while (index < encoded.length) {
        let b,
          shift = 0,
          result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        let dlat = result & 1 ? ~(result >> 1) : result >> 1;
        lat += dlat;

        shift = 0;
        result = 0;
        do {
          b = encoded.charCodeAt(index++) - 63;
          result |= (b & 0x1f) << shift;
          shift += 5;
        } while (b >= 0x20);
        let dlng = result & 1 ? ~(result >> 1) : result >> 1;
        lng += dlng;

        points.push({ lat: lat / 1e5, lng: lng / 1e5 });
      }
      return points;
    },
    applyTrafficLayer() {
      if (!this.trafficLayer || !this.map) return;
      this.trafficLayer.setMap(this.trafficEnabled ? this.map : null);
    },
    toggleTraffic(enabled) {
      if (typeof enabled === 'boolean') {
        this.trafficEnabled = enabled;
      } else {
        this.trafficEnabled = !this.trafficEnabled;
      }
      this.applyTrafficLayer();
    },
    toggleZones(enabled, zones = []) {
      if (enabled) {
        this.clearZones();
        this.drawZones(zones);
        return;
      }
      this.clearZones();
    },
    centerOnVehicle(lat, lon, zoom = 17) {
      if (!this.map) return;
      const latNum = Number(lat);
      const lngNum = Number(lon);
      if (!Number.isFinite(latNum) || !Number.isFinite(lngNum)) return;
      this.map.setCenter({ lat: latNum, lng: lngNum });
      if (Number.isFinite(zoom)) {
        this.map.setZoom(zoom);
      }
    },
  },
};
